<!-- 基于cup_table组件原有功能二次扩展的新组件（兼容cup_table组件的数据结果）应用在综合性运动会中的项目；
  1、新增了固定顶部表格header功能 
  2、新增表格展开行功能
  3、向父组件传递事件
  4、其他新增
-->

<template>
  <div
    class="compreSportsMeet_loadTree_table"
    :class="[
      tableMode,
      tabType,
      isClickFlag ? 'click' : '',
      isBroadCastList ? 'onlyDisplay' : '',
      notJumpDetailPage.includes(sportCompetitionType)
        ? 'notJumpDetailPageClass'
        : '',
    ]"
    v-if="currThemeObj.cssStyle && tableData && parentWidthPx"
  >
    <div
      v-if="
        (tableMode === 'eventComp_mode_9' ||
          tableMode === 'eventComp_mode_10' ||
          tableMode === 'eventComp_mode_22' ||
          tableMode === 'eventComp_mode_14' ||
          tableMode === 'eventComp_mode_15') &&
        compTableColumnData[0]
      "
      @click="isTableAllExpand(!isExpandAll)"
      class="table_head_arrow"
      :style="{
        width: `${
          2 * compTableColumnData[0][compTableColumnData[0].length - 1].widthPx
        }px`,
      }"
    >
      <span class="arrowIcon">
        <span
          class="el-icon el-icon-arrow-right"
          :class="isExpandAll ? 'open' : ''"
        ></span>
      </span>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :border="tableMode === 'eventComp_mode_23' ? true : false"
      :max-height="tableHeightPx ? tableHeightPx : 'auto'"
      :default-expand-all="tableData ? true : false"
      header-row-class-name="mixtmt_table_header"
      :header-cell-style="headerRowStyle"
      :cell-style="cellStyle"
      @header-click="headerClick"
      :span-method="spanMethod ? spanMethod : arraySpanMethod"
      :row-class-name="tableRowClassName"
    >
      <!-- :span-method="spanMethod?spanMethod:arraySpanMethod" -->
      <el-table-column
        v-for="column in compTableColumnData[0]"
        :fixed="column.fixed ? column.fixed : false"
        :prop="column.prop"
        :label="column.label"
        :width="column.widthPx"
        :class-name="column.className ? column.className : ''"
        :key="column.prop"
        :type="expandKey && column.prop === expandKey ? 'expand' : ''"
      >
        <template slot="header">
          <template
            v-if="
              [
                'medalTally',
                'themeItem_medalTally',
                'themeItem_delegationEventMedalTally',
              ].includes(tableMode)
            "
          >
            <span v-if="column.prop == 'gold'" class="medalType">
              <span class="medalTypeItem ME_GOLD"></span>
            </span>
            <span v-if="column.prop == 'silver'" class="medalType">
              <span class="medalTypeItem ME_SILVER"></span>
            </span>
            <span v-if="column.prop == 'bronze'" class="medalType">
              <span class="medalTypeItem ME_BRONZE"></span>
            </span>
          </template>
        </template>
        <template slot-scope="scope">
          <!-- tableMode = "medalTally | themeItem_medalTally | themeItem_delegationEventMedalTally" -->
          <span
            v-if="column.prop == 'delegationLogo-delegationName'"
            :class="column.prop"
          >
            <span
              class="delegationLogo"
              :class="scope.row['delegationLogo'] ? 'isLogo' : ''"
            >
              <img
                v-if="scope.row['delegationLogo']"
                :src="scope.row['delegationLogo']"
              />
            </span>
            <span
              class="delegationName"
              v-text="_valPerFormatHandler(scope.row['delegationName'])"
            ></span>
          </span>

          <!-- tableMode = "medalTally" -->
          <span
            v-else-if="
              column.prop === expandKey &&
              compTableColumnData[1] &&
              tableMode === 'medalTally'
            "
            class="expandBox"
            :class="scope.row && scope.row.isShowChild ? 'show' : ''"
            :style="{
              height:
                scope.row.isShowChild &&
                scope.row[expandKey] &&
                scope.row[expandKey].list
                  ? `${scope.row[expandKey].currHeightVw}vw`
                  : 0,
            }"
          >
            <span
              class="expandInfor_group"
              v-for="childData1Row in scope.row[expandKey].list"
              :key="childData1Row.id"
            >
              <span class="expand_header_row">
                <span
                  v-for="(expandColumn1, expandColumn1Index) in scope.row
                    .childKeyArr1"
                  :key="expandColumn1.prop"
                  :class="
                    compTableColumnData[1][expandColumn1Index] &&
                    compTableColumnData[1][expandColumn1Index].className
                      ? compTableColumnData[1][expandColumn1Index].className
                      : expandColumn1.prop
                  "
                  :style="{
                    width: `${
                      compTableColumnData[1][expandColumn1Index] &&
                      compTableColumnData[1][expandColumn1Index].widthPx
                        ? compTableColumnData[1][expandColumn1Index].widthPx
                        : 0
                    }px`,
                  }"
                >
                  <span
                    v-if="expandColumn1.prop === 'arrowIcon'"
                    class="el-icon el-icon-arrow-right"
                    :class="childData1Row.isOpen ? 'open' : ''"
                    @click="open2Child(childData1Row.id, scope.row)"
                  ></span>
                  <span
                    v-else
                    v-text="childData1Row[expandColumn1.prop]"
                  ></span>
                </span>
              </span>
              <span
                class="expand_body_group"
                :style="{
                  height:
                    childData1Row.isOpen && compTableColumnData[2]
                      ? `${
                          childData1Row.children.length *
                          scope.row[expandKey].childRowHeightVw
                        }vw`
                      : '0',
                }"
              >
                <span
                  class="expand_body_row"
                  v-for="(expand2_row, expand2_index) in childData1Row.children"
                  :key="expand2_index"
                >
                  <template v-if="tableMode === 'medalTally'">
                    <template
                      v-for="(expandColumn2, expandColumn2Index) in scope.row
                        .childKeyArr2"
                    >
                      <span
                        v-if="
                          expandColumn2.prop ===
                          'medalType-playerName-matchName'
                        "
                        :key="expandColumn2.prop"
                        :class="
                          compTableColumnData[2][expandColumn2Index].className
                        "
                        :style="{
                          width: `${compTableColumnData[2][expandColumn2Index].widthPx}px`,
                        }"
                      >
                        <span
                          class="medalType"
                          :class="expand2_row['medalType']"
                        ></span>
                        <span
                          class="playerName"
                          v-text="expand2_row['playerName']"
                        ></span>
                        <span
                          class="matchName"
                          v-text="expand2_row['matchName']"
                        ></span>
                      </span>
                      <span
                        :key="`${expandColumn2.prop}_else`"
                        :style="{
                          width: `${compTableColumnData[2][expandColumn2Index].widthPx}px`,
                        }"
                        v-else
                        v-text="''"
                      ></span>
                    </template>
                  </template>
                </span>
              </span>
            </span>
          </span>

          <!-- 分享按钮  -->
          <span
            v-else-if="column.prop === 'publishBtn'"
            :class="column.prop"
            @click="clickPublicTheme(scope.row)"
          >
            <svg
              t="1692698307306"
              class="publishBtn_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9670"
              width="50%"
              height="50%"
            >
              <path
                d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                p-id="9671"
              ></path>
            </svg>
          </span>

          <!-- tableMode = "compreSportsMeet" -->
          <span
            v-else-if="column.prop == 'rankNum-teamLogo-teamName'"
            :class="column.prop"
          >
            <span class="rankNum" v-text="scope.row['rank_num']"></span>
            <span
              class="teamLogo"
              :class="scope.row['team_logo'] ? 'isLogo' : ''"
            >
              <img
                v-if="scope.row['team_logo']"
                :src="scope.row['team_logo']"
              />
            </span>
            <span
              class="teamName"
              v-text="_valPerFormatHandler(scope.row['team_name'], scope.row['isQualified'] ? '(晋级)' : '')"
              @click="goDetail('CSMeetDelegationDetailIndex', scope.row)"
            ></span>
          </span>

          <!-- tableMode = "eventComp_mode_3 && 柔道品势" -->
          <template
            v-else-if="
              ['eventComp_mode_3'].includes(tableMode) &&
              sportsId === 'TKW' &&
              tabType === 'localData' &&
              [
                'teamLogo-teamName',
                'playerName-playerLogo-playerGender-teamLogo-teamName',
              ].includes(column.prop)
            "
          >
            <template v-if="scope.row['ranking']">
              <span
                v-if="column.prop == 'teamLogo-teamName'"
                :class="column.prop"
              >
                <span
                  class="teamLogo"
                  :class="scope.row['team_logo'] ? 'isLogo' : ''"
                >
                  <img
                    v-if="scope.row['team_logo']"
                    :src="scope.row['team_logo']"
                  />
                </span>
                <span
                  class="teamName"
                  v-text="_valPerFormatHandler(scope.row['team_name'])"
                  @click="goDetail('CSMeetDelegationDetailIndex', scope.row)"
                ></span>
              </span>
              <span
                v-else-if="
                  [
                    'playerName-playerLogo-playerGender-teamLogo-teamName',
                  ].includes(column.prop)
                "
                :class="column.prop"
              >
                <span
                  class="playerLogo"
                  :class="[
                    scope.row['player_logo'] ? 'isLogo' : '',
                    scope.row['player_gender'],
                  ]"
                >
                  <img
                    v-if="scope.row['player_logo']"
                    :src="scope.row['player_logo']"
                  />
                </span>
                <span class="playerOther">
                  <span class="teamInfor">
                    <span
                      class="teamLogo"
                      :class="scope.row['team_logo'] ? 'isLogo' : ''"
                    >
                      <img
                        v-if="scope.row['team_logo']"
                        :src="scope.row['team_logo']"
                      />
                    </span>
                    <span
                      class="teamName"
                      v-text="_valPerFormatHandler(scope.row['team_name'])"
                    ></span>
                  </span>
                  <span
                    class="playerName"
                    v-text="_valPerFormatHandler(scope.row['player_name'])"
                    @click="goDetail('CSMeetPlayerDetailIndex', scope.row)"
                  ></span>
                </span>
              </span>
            </template>
            <template v-else>
              <!-- 品势没有数据的第二行 -->
              <span :class="column.prop"></span>
            </template>
          </template>

          <!-- tableMode = "eventComp_mode_3 || eventComp_mode_6 || eventComp_mode_10 || eventComp_mode_13 || eventComp_mode_22 || eventComp_mode_26 || eventComp_mode_24" -->
          <span
            v-else-if="column.prop == 'teamLogo-teamName'"
            :class="column.prop"
          >
            <span
              class="teamLogo"
              :class="scope.row['team_logo'] ? 'isLogo' : ''"
              :text="JSON.stringify(scope.row)"
            >
              <img
                v-if="scope.row['team_logo']"
                :src="scope.row['team_logo']"
              />
            </span>
            <span
              class="teamName"
              v-text="_valPerFormatHandler(scope.row['team_name'])"
              @click="goDetail('CSMeetDelegationDetailIndex', scope.row)"
            ></span>
          </span>

          <!--['playerName-playerLogo-playerGender-teamLogo-teamName'] tableMode = "eventComp_mode_1 || eventComp_mode_3 || eventComp_mode_6 ||eventComp_mode_13 || eventComp_mode_8" -->
          <span
            v-else-if="
              [
                'playerName-playerLogo-playerGender-teamLogo-teamName',
                'playerName-playerLogo-playerGender-teamLogo-teamName-FEN',
              ].includes(column.prop)
            "
            :class="column.prop"
          >
            <template
              v-if="
                scope.row['player_infos'] &&
                scope.row['player_infos'].length > 0
              "
            >
              <span
                class="playerLogo"
                :class="[
                  scope.row['player_infos'][0].player_logo ? 'isLogo' : '',
                  scope.row['player_infos'][0].player_gender,
                ]"
              >
                <img
                  v-if="scope.row['player_infos'][0].player_logo"
                  :src="scope.row['player_infos'][0].player_logo"
                />
              </span>
              <span class="playerOther">
                <span class="teamInfor">
                  <span
                    class="teamLogo"
                    :class="scope.row['team_logo'] ? 'isLogo' : ''"
                  >
                    <img
                      v-if="scope.row['team_logo']"
                      :src="scope.row['team_logo']"
                    />
                  </span>
                  <span
                    class="teamName"
                    v-text="_valPerFormatHandler(scope.row['team_name'])"
                  ></span>
                </span>
                <span
                  class="playerName"
                  v-text="
                    _valPerFormatHandler(
                      scope.row['player_infos'][0].player_name
                    )
                  "
                  @click="
                    goDetail(
                      'CSMeetPlayerDetailIndex',
                      scope.row['player_infos'][0]
                    )
                  "
                ></span>
              </span>
            </template>
            <template v-else>
              <span
                class="playerLogo"
                :class="[
                  scope.row['player_logo'] ? 'isLogo' : '',
                  scope.row['player_gender'],
                ]"
              >
                <img
                  v-if="scope.row['player_logo']"
                  :src="scope.row['player_logo']"
                />
              </span>
              <span class="playerOther">
                <span class="teamInfor">
                  <span
                    class="teamLogo"
                    :class="
                      scope.row['team_logo'] || scope.row['country_logo']
                        ? 'isLogo'
                        : ''
                    "
                  >
                    <img
                      v-if="scope.row['team_logo'] || scope.row['country_logo']"
                      :src="
                        scope.row['team_logo']
                          ? scope.row['team_logo']
                          : scope.row['country_logo']
                      "
                    />
                  </span>
                  <span
                    class="teamName"
                    v-text="
                      _valPerFormatHandler(
                        scope.row['team_name']
                          ? scope.row['team_name']
                          : scope.row['country_name']
                      )
                    "
                  ></span>
                </span>
                <span
                  class="playerName"
                  v-text="_valPerFormatHandler(scope.row['player_name'])"
                  @click="goDetail('CSMeetPlayerDetailIndex', scope.row)"
                ></span>
              </span>
            </template>
          </span>

          <!-- tableMode = "eventComp_mode_3" 击剑 带V图标的表格 -->
          <template v-else-if="column.prop.indexOf('FEN_boutItem') > -1">
            <template
              v-if="
                ['V', 'v'].includes(scope.row[column.prop.split('_FEN_')[0]])
              "
            >
              <span class="FEN_boutItem_cell valIsV"></span>
            </template>
            <template v-else-if="!scope.row[column.prop.split('_FEN_')[0]]">
              <span class="FEN_boutItem_cell notVal"></span>
            </template>
            <template v-else>
              <span
                class="FEN_boutItem_cell"
                v-text="scope.row[column.prop.split('_FEN_')[0]]"
              ></span>
            </template>
          </template>

          <!-- tableMode = "eventComp_mode_10 ||  eventComp_mode_22 || eventComp_mode_26 || eventComp_mode_26 || eventComp_mode_24 || eventComp_mode_16" -->
          <span
            v-else-if="column.prop == 'teamLogo-teamName-playerListString'"
            :class="column.prop"
          >
            <span
              class="teamLogo"
              :class="scope.row['team_logo'] ? 'isLogo' : ''"
            >
              <img
                v-if="scope.row['team_logo']"
                :src="scope.row['team_logo']"
              />
            </span>
            <span
              class="teamName"
              v-text="_valPerFormatHandler(scope.row['team_name'])"
            ></span>
            <span
              class="playerList"
              :class="
                ['T', 'A', 'D'][
                  scope.row['player_infos'] && scope.row['player_infos'].length
                    ? scope.row['player_infos'].length
                    : 0
                ]
              "
              v-if="
                scope.row['player_infos'] &&
                scope.row['player_infos'].length > 0
              "
            >
              <span
                class="player_item"
                v-for="player in scope.row['player_infos']"
                :key="player.player_id"
              >
                <span
                  class="playerItem_name"
                  v-text="_valPerFormatHandler(player.player_name)"
                  @click="goDetail('CSMeetPlayerDetailIndex', player)"
                ></span>
              </span>
            </span>
          </span>

          <!-- tableMode = "eventComp_mode_6 || eventComp_mode_13 || eventComp_mode_27 || eventComp_mode_8" -->
          <span
            v-else-if="column.prop == 'teamLogo-playerListString'"
            :class="column.prop"
          >
            <span
              class="teamLogo"
              :class="scope.row['team_logo'] ? 'isLogo' : ''"
            >
              <img
                v-if="scope.row['team_logo']"
                :src="scope.row['team_logo']"
              />
            </span>
            <span
              class="playerList"
              :class="
                ['T', 'A', 'D'][
                  scope.row['players'] && scope.row['players'].length
                    ? scope.row['players'].length
                    : 0
                ]
              "
              v-if="scope.row['players'] && scope.row['players'].length > 0"
            >
              <span
                class="player_item"
                v-for="player in scope.row['players']"
                :key="player.player_id"
              >
                <span
                  class="playerItem_name"
                  v-text="_valPerFormatHandler(player.player_name)"
                  @click="goDetail('CSMeetPlayerDetailIndex', player)"
                ></span>
              </span>
            </span>
          </span>

          <!-- tableMode = "eventComp_mode_6" -->
          <span
            v-else-if="column.prop == 'singleRow-teamLogoPlayer'"
            :class="column.prop"
          >
            <!-- 中网双人 -->
            <template
              v-if="scope.row['players'] && scope.row['players'].length > 0"
            ></template>
            <span
              class="teamPlayerItem"
              :class="
                ['T', 'A', 'D'][
                  scope.row['players'] && scope.row['players'].length
                    ? scope.row['players'].length
                    : 0
                ]
              "
              v-for="player in scope.row['players']"
              :key="player.player_id"
            >
              <span
                class="teamLogo"
                :class="player['country_logo'] ? 'isLogo' : ''"
              >
                <img
                  v-if="player['country_logo']"
                  :src="player['country_logo']"
                />
              </span>
              <span class="player_item">
                <span
                  class="playerItem_name"
                  v-text="_valPerFormatHandler(player.player_name)"
                  @click="goDetail('CSMeetPlayerDetailIndex', player)"
                ></span>
              </span>
              <!-- <span
                class="playerList"
                :class="
                  ['T', 'A', 'D'][
                    scope.row['players'] && scope.row['players'].length
                      ? scope.row['players'].length
                      : 0
                  ]
                "
                v-if="scope.row['players'] && scope.row['players'].length > 0"
              >
                <span
                  class="player_item"
                  v-for="player in scope.row['players']"
                  :key="player.player_id"
                >
                  <span
                    class="playerItem_name"
                    v-text="_valPerFormatHandler(player.player_name)"
                    @click="goDetail('CSMeetPlayerDetailIndex', player)"
                  ></span>
                </span>
              </span> -->
            </span>
          </span>

          <!-- tableMode = "records_table" -->
          <span
            v-else-if="
              column.prop == 'playerNameList' && tableMode === 'records_table'
            "
            class="playerListString"
            v-text="_valPerFormatHandler(scope.row['playerListString'])"
          ></span>

          <!-- tableMode = "records_table" -->
          <span
            v-else-if="
              column.prop == 'sportsNameEventName' &&
              tableMode === 'records_table'
            "
            :class="column.prop"
            v-text="scope.row['sportsNameEventNameWeb']"
          ></span>

          <!-- tableMode = "records_table" -->
          <span
            v-else-if="
              column.prop == 'delegationLogo-delegationId-delegationName' &&
              tableMode === 'records_table'
            "
            :class="column.prop"
          >
            <span class="delegationItem">
              <span
                class="delegationLogo"
                :class="scope.row['delegationLogo'] ? 'isLogo' : ''"
              >
                <img
                  v-if="scope.row['delegationLogo']"
                  :src="scope.row['delegationLogo']"
                />
              </span>
              <span
                class="delegationId"
                v-text="_valPerFormatHandler(scope.row['delegationId'])"
              ></span>
            </span>
            <span
              class="delegationName"
              v-text="_valPerFormatHandler(scope.row['delegationName'])"
            ></span>
          </span>

          <!-- tableMode = "medalTally || eventComp_mode_1 || eventComp_mode_10 || eventComp_mode_22 || eventComp_mode_26" -->
          <span v-else-if="column.prop === 'arrowIcon'" :class="column.prop">
            <span
              v-if="scope.row.isHasDetailData"
              class="el-icon el-icon-arrow-right"
              :class="scope.row && scope.row.isShowChild ? 'open' : ''"
              @click="open1Child(scope.row)"
            ></span>
          </span>

          <!-- tableMode = "eventComp_mode_13" -->
          <span v-else-if="column.prop.indexOf('_color') > -1" class="color">
            <span
              class="colorArea"
              :style="{
                backgroundColor: `${scope.row[column.prop]}`,
                borderColor: `${
                  ['WHITE', 'white'].includes(scope.row[column.prop])
                    ? 'GREY'
                    : scope.row[column.prop]
                }`,
              }"
            ></span>
          </span>

          <!--tableMode = "eventComp_mode_19" -->
          <template
            v-else-if="
              tableMode === 'eventComp_mode_19' &&
              column.prop.indexOf('Mode19_') > -1
            "
          >
            <span
              v-if="
                [
                  'homeMode19_playerName-playerLogo-playerGender-teamLogo-teamName',
                  'awayMode19_playerName-playerLogo-playerGender-teamLogo-teamName',
                ].includes(column.prop)
              "
              :class="tableMode"
              class="playerName-playerLogo-playerGender-teamLogo-teamName"
            >
              <span
                class="playerLogo"
                :class="[
                  scope.row[`${column.prop.split('Mode19_')[0]}_player_logo`]
                    ? 'isLogo'
                    : '',
                  scope.row[`${column.prop.split('Mode19_')[0]}player_gender`],
                ]"
              >
                <img
                  v-if="
                    scope.row[`${column.prop.split('Mode19_')[0]}_player_logo`]
                  "
                  :src="
                    scope.row[`${column.prop.split('Mode19_')[0]}_player_logo`]
                  "
                />
              </span>
              <span class="playerOther">
                <span class="teamInfor">
                  <span
                    class="teamLogo"
                    :class="
                      scope.row[`${column.prop.split('Mode19_')[0]}_team_logo`]
                        ? 'isLogo'
                        : ''
                    "
                  >
                    <img
                      v-if="
                        scope.row[
                          `${column.prop.split('Mode19_')[0]}_team_logo`
                        ]
                      "
                      :src="
                        scope.row[
                          `${column.prop.split('Mode19_')[0]}_team_logo`
                        ]
                      "
                    />
                  </span>
                  <span
                    class="teamName"
                    v-text="
                      _valPerFormatHandler(
                        scope.row[
                          `${column.prop.split('Mode19_')[0]}_team_name`
                        ]
                      )
                    "
                  ></span>
                </span>
                <span
                  class="playerName"
                  v-text="
                    _valPerFormatHandler(
                      scope.row[
                        `${column.prop.split('Mode19_')[0]}_player_name`
                      ]
                    )
                  "
                  @click="
                    goDetail(
                      'CSMeetPlayerDetailIndex',
                      null,
                      scope.row[`${column.prop.split('Mode19_')[0]}_player_id`]
                    )
                  "
                ></span>
              </span>
            </span>
            <span
              v-else-if="
                [
                  'homeMode19_playerName-playerLogo',
                  'awayMode19_playerName-playerLogo',
                ].includes(column.prop)
              "
              :class="tableMode"
              class="playerName-playerLogo"
            >
              <span
                class="playerLogo"
                :class="[
                  scope.row[`${column.prop.split('Mode19_')[0]}_player_logo`]
                    ? 'isLogo'
                    : '',
                  scope.row[`${column.prop.split('Mode19_')[0]}player_gender`],
                ]"
              >
                <img
                  v-if="
                    scope.row[`${column.prop.split('Mode19_')[0]}_player_logo`]
                  "
                  :src="
                    scope.row[`${column.prop.split('Mode19_')[0]}_player_logo`]
                  "
                />
              </span>
              <span
                class="playerName"
                v-text="
                  _valPerFormatHandler(
                    scope.row[`${column.prop.split('Mode19_')[0]}_player_name`]
                  )
                "
                @click="
                  goDetail(
                    'CSMeetPlayerDetailIndex',
                    null,
                    scope.row[`${column.prop.split('Mode19_')[0]}_player_id`]
                  )
                "
              ></span>
            </span>
          </template>

          <!--[expandKey] tableMode = "eventComp_mode_1" -->
          <span
            v-else-if="
              column.prop === expandKey && tableMode === 'eventComp_mode_1'
            "
            class="expandBox"
            :class="scope.row && scope.row.isShowChild ? 'show' : ''"
            :style="{
              height:
                scope.row.isShowChild &&
                scope.row[expandKey] &&
                scope.row[expandKey].list
                  ? `${scope.row[expandKey].currHeightVw}vw`
                  : 0,
            }"
          >
            <template v-if="scope.row.isHasDetailData">
              <span
                class="half_table_group"
                v-for="(group, gIndex) in scope.row[expandKey].list"
                :key="gIndex"
              >
                <span class="table_title" v-text="groupTitleArr[gIndex]"></span>
                <span class="table_main">
                  <span class="table_head_gruop" v-text="'环数'"></span>
                  <span class="customTable">
                    <span class="customTable_row">
                      <span
                        class="customTable_row_cell"
                        v-for="headRow in group.table_head"
                        :key="headRow.map_key_arr[0]"
                        v-text="headRow.name"
                      ></span>
                    </span>
                    <span
                      class="customTable_row"
                      v-for="(datas, dataIndex) in group.data"
                      :key="dataIndex"
                    >
                      <span
                        class="customTable_row_cell"
                        v-for="headRow in group.table_head"
                        :key="headRow.map_key_arr[0]"
                        v-text="datas[headRow.map_key_arr[0]]"
                      ></span>
                    </span>
                  </span>
                </span>
              </span>
            </template>
          </span>

          <!--[expandKey] tableMode = "eventComp_mode_9" -->
          <span
            v-else-if="
              column.prop === expandKey && tableMode === 'eventComp_mode_9'
            "
            class="expandBox"
            :class="scope.row && scope.row.isShowChild ? 'show' : ''"
            :style="{
              height:
                scope.row.isShowChild &&
                scope.row[expandKey] &&
                scope.row[expandKey].list
                  ? `${scope.row[expandKey].currHeightVw}vw`
                  : 0,
            }"
          >
            <template v-if="scope.row.isHasDetailData">
              <span
                class="table_group"
                :class="[
                  scope.row[expandKey].expandClassString,
                  scope.row[expandKey].renderMode,
                  scope.row[expandKey].renderMode === 'SWM' &&
                  scope.row[expandKey].list &&
                  scope.row[expandKey].list.data &&
                  scope.row[expandKey].list.data.length > 9
                    ? 'overflowXAuto'
                    : '',
                ]"
                :style="{
                  paddingLeft: `${
                    compTableColumnData[0][0]
                      ? compTableColumnData[0][0].widthPx
                      : 0
                  }px`,
                }"
              >
                <template v-if="scope.row[expandKey].renderMode === 'SWM'">
                  <span
                    class="columnItem"
                    v-for="(columData, gIndex) in scope.row[expandKey].list
                      .data"
                    :key="gIndex"
                  >
                    <span
                      class="columnItem_row"
                      v-text="
                        _valPerFormatHandler(columData['intermediate_name'])
                      "
                    ></span>
                    <span
                      class="columnItem_row"
                      v-text="
                        `${_valPerFormatHandler(
                          columData['intermediate_result']
                        )}${
                          columData['intermediate_rank']
                            ? ' (' + columData['intermediate_rank'] + ')'
                            : ''
                        }`
                      "
                    ></span>
                  </span>
                </template>
                <template
                  v-else-if="
                    ['ROW', 'RCB'].includes(scope.row[expandKey].renderMode)
                  "
                >
                  <span
                    class="columnItem"
                    v-for="(columData, gIndex) in scope.row[expandKey].list
                      .data"
                    :key="gIndex"
                  >
                    <span
                      class="columnItem_row"
                      v-text="
                        _valPerFormatHandler(columData['intermediate_name'])
                      "
                    ></span>
                    <span
                      class="columnItem_row"
                      v-for="(resColum, resInd) in columData[
                        'intermediate_result'
                      ]"
                      :key="resInd"
                      v-text="`${resColum !== null ? resColum : ''}`"
                    ></span>
                  </span>
                </template>
                <template v-else>
                  <span
                    class="columnItem"
                    v-for="(columData, gIndex) in scope.row[expandKey].list
                      .data"
                    :key="gIndex"
                  >
                    <span
                      class="columnItem_row"
                      v-for="columKey in scope.row[expandKey].list.table_head"
                      :key="columKey.map_key_arr[0]"
                      v-text="columData[columKey.map_key_arr[0]]"
                    ></span>
                  </span>
                </template>
              </span>
            </template>
          </span>

          <!--[expandKey] tableMode = "eventComp_mode_10 | eventComp_mode_22 || eventComp_mode_26" -->
          <span
            v-else-if="
              column.prop === expandKey &&
              [
                'eventComp_mode_10',
                'eventComp_mode_22',
                'eventComp_mode_26',
              ].includes(tableMode)
            "
            class="expandBox"
            :class="scope.row && scope.row.isShowChild ? 'show' : ''"
            :style="{
              height:
                scope.row.isShowChild &&
                scope.row[expandKey] &&
                scope.row[expandKey].list
                  ? `${scope.row[expandKey].currHeightVw}vw`
                  : 0,
            }"
          >
            <template v-if="scope.row.isHasDetailData">
              <template
                v-if="
                  ['DIV', 'FRS', 'SBD'].includes(
                    scope.row[expandKey].renderMode
                  ) &&
                  competitorType !== 'T' &&
                  scope.row[expandKey].tabType === 'localData' &&
                  scope.row[expandKey].expandModeName === 'expand_default'
                "
              >
                <span class="customDIV_table" :class="competitorType">
                  <span
                    class="group_title"
                    v-if="scope.row[expandKey].groupTitleObj"
                    :style="{
                      width: `${scope.row[expandKey].groupTitleObj.width}vw`,
                      paddingLeft: `${scope.row[expandKey].groupTitleObj.paddingLeft}vw`,
                      paddingRight: `${scope.row[expandKey].groupTitleObj.paddingRight}vw`,
                    }"
                    v-text="'裁判分'"
                  ></span>
                  <span class="rowData fontBold">
                    <span
                      class="rowData_item"
                      v-for="(columnData, rowIndex) in scope.row[expandKey].list
                        .table_head"
                      :class="columnData.className ? columnData.className : ''"
                      :key="rowIndex"
                      v-text="columnData.name"
                    ></span>
                  </span>
                  <span
                    class="rowData"
                    v-for="(rowData, rowIndex) in scope.row[expandKey].list
                      .data"
                    :key="rowIndex"
                  >
                    <span
                      class="rowData_item"
                      v-for="(columnData, rowIndex) in scope.row[expandKey].list
                        .table_head"
                      :class="[
                        columnData.className ? columnData.className : '',
                        rowData.textLineThroughArr &&
                        rowData.textLineThroughArr.includes(
                          columnData.map_key_arr[0]
                        )
                          ? 'textLineThrough'
                          : '',
                      ]"
                      :key="rowIndex"
                      v-text="rowData[columnData.map_key_arr[0]]"
                    ></span>
                  </span>
                </span>
              </template>

              <template
                v-else-if="
                  scope.row[expandKey].renderMode === 'GAR' &&
                  scope.row[expandKey].tabType === 'teamResult'
                "
              >
                <span class="playerList">
                  <span
                    class="playerList_item"
                    :class="scope.row[expandKey].tabType"
                    v-for="playerItem in scope.row[expandKey].list.data"
                    :key="playerItem.player_id"
                  >
                    <!-- [排名+运动员+otherList] -->
                    <span
                      class="baton_name"
                      v-text="_valPerFormatHandler(playerItem['ranking'])"
                      :style="{
                        width: `${
                          compTableColumnData[0][
                            scope.row[expandKey].defaultInsertCustomColuIndex
                          ].widthPx
                        }px`,
                      }"
                    ></span>
                    <span
                      class="playerName-playerLogo-playerGender"
                      :style="{
                        width: `${
                          compTableColumnData[0][
                            scope.row[expandKey].defaultInsertCustomColuIndex +
                              1
                          ].widthPx
                        }px`,
                      }"
                    >
                      <span
                        class="playerLogo"
                        :class="[
                          playerItem['player_logo'] ? 'isLogo' : '',
                          playerItem['player_gender'],
                        ]"
                      >
                        <img
                          v-if="playerItem['player_logo']"
                          :src="playerItem['player_logo']"
                        />
                      </span>
                      <span class="playerOther">
                        <span
                          class="playerName"
                          v-text="
                            _valPerFormatHandler(playerItem['player_name'])
                          "
                          @click="
                            goDetail('CSMeetPlayerDetailIndex', playerItem)
                          "
                        ></span>
                      </span>
                    </span>
                    <template
                      v-if="
                        scope.row[expandKey]['expandOtherList_head'] &&
                        scope.row[expandKey]['expandOtherList_head'].length > 0
                      "
                    >
                      <span
                        class="personResult"
                        v-for="otherColum in scope.row[expandKey][
                          'expandOtherList_head'
                        ]"
                        :key="otherColum.name"
                        v-text="
                          _valPerFormatHandler(playerItem[otherColum.prop])
                        "
                        :style="{
                          width: `${
                            compTableColumnData[0][
                              scope.row[expandKey]
                                .defaultInsertCustomColuIndex + 2
                            ].widthPx
                          }px`,
                        }"
                      ></span>
                    </template>
                  </span>
                </span>
              </template>

              <template v-else>
                <span
                  class="playerList"
                  :style="{
                    paddingLeft: `${
                      compTableColumnData[0] &&
                      compTableColumnData[0].length > 0
                        ? computedExpandPadLeftWidth(
                            scope.row[expandKey].defaultInsertCustomColuIndex,
                            compTableColumnData[0]
                          )
                        : 0
                    }px`,
                  }"
                >
                  <template v-if="scope.row[expandKey].tabType === 'startList'">
                    <span
                      class="playerList_item"
                      :class="scope.row[expandKey].tabType"
                      v-for="playerItem in scope.row[expandKey].list"
                      :key="playerItem.player_id"
                    >
                      <template
                        v-if="
                          [
                            'SKN',
                            'NCB',
                            'SJP',
                            'LUG',
                            'BOB',
                            'ALP',
                            'SWM',
                            'DIV',
                            'TKW',
                            'STK',
                            'SSK',
                            'CCS',
                            'BTH',
                            'SMT',
                            'FRS',
                            'ATW',
                          ].includes(scope.row[expandKey].renderMode)
                        "
                      >
                        <span class="playerName-playerLogo-playerGender">
                          <span
                            class="playerLogo"
                            :class="[
                              playerItem['player_logo'] ? 'isLogo' : '',
                              playerItem['player_gender'],
                            ]"
                          >
                            <img
                              v-if="playerItem['player_logo']"
                              :src="playerItem['player_logo']"
                            />
                          </span>
                          <span class="playerOther">
                            <span
                              class="playerName"
                              v-text="
                                _valPerFormatHandler(playerItem['player_name'])
                              "
                              @click="
                                goDetail('CSMeetPlayerDetailIndex', playerItem)
                              "
                            ></span>
                          </span>
                        </span>
                      </template>
                      <template
                        v-if="scope.row[expandKey].renderMode === 'ATH'"
                      >
                        <span
                          class="baton_name"
                          v-text="
                            _valPerFormatHandler(playerItem['bib_number'])
                          "
                        ></span>
                        <span class="playerName-playerLogo-playerGender">
                          <span
                            class="playerLogo"
                            :class="[
                              playerItem['player_logo'] ? 'isLogo' : '',
                              playerItem['player_gender'],
                            ]"
                          >
                            <img
                              v-if="playerItem['player_logo']"
                              :src="playerItem['player_logo']"
                            />
                          </span>
                          <span class="playerOther">
                            <span
                              class="playerName"
                              v-text="
                                _valPerFormatHandler(playerItem['player_name'])
                              "
                              @click="
                                goDetail('CSMeetPlayerDetailIndex', playerItem)
                              "
                            ></span>
                          </span>
                        </span>
                      </template>
                    </span>
                  </template>
                  <template v-if="scope.row[expandKey].tabType === 'localData'">
                    <span
                      class="playerList_item"
                      :class="scope.row[expandKey].tabType"
                      v-for="playerItem in scope.row[expandKey].list.data"
                      :key="playerItem.player_id"
                    >
                      <template
                        v-if="
                          scope.row[expandKey].renderMode === 'BOB' ||
                          scope.row[expandKey].renderMode === 'ALP' ||
                          scope.row[expandKey].renderMode === 'SWM' ||
                          (['FRS', 'SBD'].includes(
                            scope.row[expandKey].renderMode
                          ) &&
                            competitorType === 'T')
                        "
                      >
                        <span
                          class="baton_name"
                          v-text="
                            _valPerFormatHandler(playerItem['baton_name'], '棒')
                          "
                        ></span>
                        <span class="playerName-playerLogo-playerGender">
                          <span
                            class="playerLogo"
                            :class="[
                              playerItem['player_logo'] ? 'isLogo' : '',
                              playerItem['player_gender'],
                            ]"
                          >
                            <img
                              v-if="playerItem['player_logo']"
                              :src="playerItem['player_logo']"
                            />
                          </span>
                          <span class="playerOther">
                            <span
                              class="playerName"
                              v-text="
                                _valPerFormatHandler(playerItem['player_name'])
                              "
                              @click="
                                goDetail('CSMeetPlayerDetailIndex', playerItem)
                              "
                            ></span>
                            <span class="player_result_rank">
                              <span
                                class="player_result"
                                v-text="
                                  _valPerFormatHandler(
                                    playerItem['player_result']
                                  )
                                "
                              ></span>
                              <span
                                class="player_rank"
                                v-text="
                                  playerItem['instant_ranking']
                                    ? `(${playerItem['instant_ranking']})`
                                    : ''
                                "
                              ></span>
                            </span>
                          </span>
                        </span>
                        <span
                          class="columnItem"
                          v-for="(
                            columData, columnIndex
                          ) in playerItem.result_detail"
                          :key="columnIndex"
                        >
                          <span
                            class="columnItem_row"
                            v-text="
                              _valPerFormatHandler(
                                columData['intermediate_name']
                              )
                            "
                          ></span>
                          <span
                            class="columnItem_row"
                            v-text="
                              `${_valPerFormatHandler(
                                columData['intermediate_result']
                              )}${
                                columData['intermediate_rank']
                                  ? ' (' + columData['intermediate_rank'] + ')'
                                  : ''
                              }`
                            "
                          ></span>
                        </span>
                      </template>

                      <template
                        v-if="
                          ['ATH', 'CCS', 'BTH', 'SMT', 'ATW'].includes(
                            scope.row[expandKey].renderMode
                          )
                        "
                      >
                        <template
                          v-if="
                            scope.row[expandKey].expandModeName ===
                            'numPlayerPersonResultRank'
                          "
                        >
                          <!-- [号码+运动员+个人成绩+个人名次] -->
                          <span
                            class="baton_name"
                            v-text="
                              _valPerFormatHandler(playerItem['bib_number'])
                            "
                            :style="{
                              width: `${
                                compTableColumnData[0][
                                  scope.row[expandKey]
                                    .defaultInsertCustomColuIndex
                                ].widthPx
                              }px`,
                            }"
                          ></span>
                          <span
                            class="playerName-playerLogo-playerGender"
                            :style="{
                              width: `${
                                compTableColumnData[0][
                                  scope.row[expandKey]
                                    .defaultInsertCustomColuIndex + 1
                                ].widthPx
                              }px`,
                            }"
                          >
                            <span
                              class="playerLogo"
                              :class="[
                                playerItem['player_logo'] ? 'isLogo' : '',
                                playerItem['player_gender'],
                              ]"
                            >
                              <img
                                v-if="playerItem['player_logo']"
                                :src="playerItem['player_logo']"
                              />
                            </span>
                            <span class="playerOther">
                              <span
                                class="playerName"
                                v-text="
                                  _valPerFormatHandler(
                                    playerItem['player_name']
                                  )
                                "
                                @click="
                                  goDetail(
                                    'CSMeetPlayerDetailIndex',
                                    playerItem
                                  )
                                "
                              ></span>
                              <span class="player_result_rank">
                                <span
                                  class="player_result"
                                  v-text="
                                    _valPerFormatHandler(
                                      playerItem['person_result']
                                    )
                                  "
                                ></span>
                                <span
                                  class="player_rank"
                                  v-text="
                                    playerItem['person_rank_num']
                                      ? `(${playerItem['person_rank_num']})`
                                      : ''
                                  "
                                ></span>
                              </span>
                            </span>
                          </span>
                        </template>

                        <template v-else>
                          <!-- 默认  -->
                          <span
                            class="baton_name"
                            v-text="
                              _valPerFormatHandler(
                                playerItem['baton_name'],
                                '棒'
                              )
                            "
                          ></span>
                          <span class="playerName-playerLogo-playerGender">
                            <span
                              class="playerLogo"
                              :class="[
                                playerItem['player_logo'] ? 'isLogo' : '',
                                playerItem['player_gender'],
                              ]"
                            >
                              <img
                                v-if="playerItem['player_logo']"
                                :src="playerItem['player_logo']"
                              />
                            </span>
                            <span class="playerOther">
                              <span
                                class="playerName"
                                v-text="
                                  _valPerFormatHandler(
                                    playerItem['player_name']
                                  )
                                "
                                @click="
                                  goDetail(
                                    'CSMeetPlayerDetailIndex',
                                    playerItem
                                  )
                                "
                              ></span>
                              <span class="player_result_rank">
                                <span
                                  class="player_result"
                                  v-text="
                                    _valPerFormatHandler(
                                      playerItem['player_result']
                                    )
                                  "
                                ></span>
                                <span
                                  class="player_rank"
                                  v-text="
                                    playerItem['instant_ranking']
                                      ? `(${playerItem['instant_ranking']})`
                                      : ''
                                  "
                                ></span>
                              </span>
                            </span>
                          </span>
                          <span
                            class="columnItem"
                            v-for="(
                              columData, columnIndex
                            ) in playerItem.result_detail"
                            :key="columnIndex"
                          >
                            <span
                              class="columnItem_row"
                              v-text="
                                _valPerFormatHandler(
                                  columData['intermediate_name']
                                )
                              "
                            ></span>
                            <span
                              class="columnItem_row"
                              v-text="
                                `${_valPerFormatHandler(
                                  columData['intermediate_result']
                                )}${
                                  columData['intermediate_rank']
                                    ? ' (' +
                                      columData['intermediate_rank'] +
                                      ')'
                                    : ''
                                }`
                              "
                            ></span>
                          </span>
                        </template>
                      </template>

                      <template
                        v-if="scope.row[expandKey].renderMode === 'SHO'"
                      >
                        <template
                          v-if="
                            scope.row[expandKey].expandModeName ===
                            'onlyPlayerInfors'
                          "
                        >
                          <!-- 默认  -->
                          <span
                            class="baton_name"
                            v-text="
                              _valPerFormatHandler(playerItem['bib_number'])
                            "
                          ></span>
                          <span
                            class="playerName-playerLogo-playerGender-teamLogo-teamName"
                            :style="{
                              width: `${computedExpandOnlyCustomAutoWidthCalc(
                                scope.row[expandKey]
                                  .defaultInsertCustomColuIndex + 1,
                                compTableColumnData[0]
                              )}`,
                            }"
                          >
                            <span
                              class="playerLogo"
                              :class="[
                                playerItem['player_logo'] ? 'isLogo' : '',
                                playerItem['player_gender'],
                              ]"
                            >
                              <img
                                v-if="playerItem['player_logo']"
                                :src="playerItem['player_logo']"
                              />
                            </span>
                            <span class="playerOther">
                              <span class="teamInfor">
                                <span
                                  class="teamLogo"
                                  :class="
                                    playerItem['team_logo'] ? 'isLogo' : ''
                                  "
                                >
                                  <img
                                    v-if="playerItem['team_logo']"
                                    :src="playerItem['team_logo']"
                                  />
                                </span>
                                <span
                                  class="teamName"
                                  v-text="
                                    _valPerFormatHandler(
                                      playerItem['team_name']
                                    )
                                  "
                                ></span>
                              </span>
                              <span
                                class="playerName"
                                v-text="
                                  _valPerFormatHandler(
                                    playerItem['player_name']
                                  )
                                "
                                @click="
                                  goDetail(
                                    'CSMeetPlayerDetailIndex',
                                    playerItem
                                  )
                                "
                              ></span>
                            </span>
                          </span>
                        </template>
                      </template>

                      <template
                        v-if="scope.row[expandKey].renderMode === 'DIV'"
                      >
                        <template
                          v-if="
                            scope.row[expandKey].expandModeName ===
                            'expandT_rowPlayers'
                          "
                        >
                          <!-- [运动员+个人名次+单项得分] -->
                          <span
                            class="playerName-playerLogo-playerGender"
                            :style="{
                              width: `${
                                Number(
                                  compTableColumnData[0][
                                    scope.row[expandKey]
                                      .defaultInsertCustomColuIndex + 1
                                  ].widthPx
                                ) +
                                Number(
                                  compTableColumnData[0][
                                    scope.row[expandKey]
                                      .defaultInsertCustomColuIndex + 2
                                  ].widthPx
                                )
                              }px`,
                            }"
                          >
                            <span
                              class="playerLogo"
                              :class="[
                                playerItem['player_logo'] ? 'isLogo' : '',
                                playerItem['player_gender'],
                              ]"
                            >
                              <img
                                v-if="playerItem['player_logo']"
                                :src="playerItem['player_logo']"
                              />
                            </span>
                            <span class="playerOther">
                              <span
                                class="playerName"
                                v-text="
                                  _valPerFormatHandler(
                                    playerItem['player_name']
                                  )
                                "
                                @click="
                                  goDetail(
                                    'CSMeetPlayerDetailIndex',
                                    playerItem
                                  )
                                "
                              ></span>
                            </span>
                          </span>
                          <span
                            class="personResult"
                            v-text="
                              _valPerFormatHandler(
                                playerItem['player_rank_num']
                              )
                            "
                            :style="{
                              width: `${
                                compTableColumnData[0][
                                  scope.row[expandKey]
                                    .defaultInsertCustomColuIndex + 3
                                ].widthPx
                              }px`,
                            }"
                          ></span>
                          <span
                            class="personRank"
                            v-text="
                              _valPerFormatHandler(playerItem['player_result'])
                            "
                            :style="{
                              width: `${
                                compTableColumnData[0][
                                  scope.row[expandKey]
                                    .defaultInsertCustomColuIndex + 4
                                ].widthPx
                              }px`,
                            }"
                          ></span>
                        </template>
                      </template>
                      <template
                        v-if="scope.row[expandKey].renderMode === 'ARC'"
                      >
                        <template
                          v-if="
                            scope.row[expandKey].expandModeName ===
                            'numPlayerPersonResultRank'
                          "
                        >
                          <!-- [号码+运动员+个人成绩+个人名次] -->
                          <span
                            class="baton_name"
                            v-text="
                              _valPerFormatHandler(playerItem['bib_number'])
                            "
                            :style="{
                              width: `${
                                compTableColumnData[0][
                                  scope.row[expandKey]
                                    .defaultInsertCustomColuIndex
                                ].widthPx
                              }px`,
                            }"
                          ></span>
                          <span
                            class="playerName-playerLogo-playerGender"
                            :style="{
                              width: `${
                                compTableColumnData[0][
                                  scope.row[expandKey]
                                    .defaultInsertCustomColuIndex + 1
                                ].widthPx
                              }px`,
                            }"
                          >
                            <span
                              class="playerLogo"
                              :class="[
                                playerItem['player_logo'] ? 'isLogo' : '',
                                playerItem['player_gender'],
                              ]"
                            >
                              <img
                                v-if="playerItem['player_logo']"
                                :src="playerItem['player_logo']"
                              />
                            </span>
                            <span class="playerOther">
                              <span
                                class="playerName"
                                v-text="
                                  _valPerFormatHandler(
                                    playerItem['player_name']
                                  )
                                "
                                @click="
                                  goDetail(
                                    'CSMeetPlayerDetailIndex',
                                    playerItem
                                  )
                                "
                              ></span>
                              <span class="player_result_rank">
                                <span
                                  class="player_result"
                                  v-text="
                                    _valPerFormatHandler(
                                      playerItem['player_result']
                                    )
                                  "
                                ></span>
                                <span
                                  class="player_rank"
                                  v-text="
                                    playerItem['instant_ranking']
                                      ? `(${playerItem['instant_ranking']})`
                                      : ''
                                  "
                                ></span>
                              </span>
                            </span>
                          </span>
                          <span
                            class="personResult"
                            v-text="
                              _valPerFormatHandler(
                                playerItem.result_detail[0]['person_result']
                              )
                            "
                            :style="{
                              width: `${
                                compTableColumnData[0][
                                  scope.row[expandKey]
                                    .defaultInsertCustomColuIndex + 2
                                ].widthPx
                              }px`,
                            }"
                          ></span>
                          <span
                            class="personRank"
                            v-text="
                              _valPerFormatHandler(
                                playerItem.result_detail[0]['score']
                              )
                            "
                            :style="{
                              width: `${
                                compTableColumnData[0][
                                  scope.row[expandKey]
                                    .defaultInsertCustomColuIndex + 3
                                ].widthPx
                              }px`,
                            }"
                          ></span>
                        </template>
                      </template>
                    </span>
                  </template>
                </span>
              </template>
            </template>
          </span>

          <!--[expandKey] tableMode = "eventComp_mode_14" -->
          <span
            v-else-if="
              column.prop === expandKey && tableMode === 'eventComp_mode_14'
            "
            class="expandBox"
            :class="scope.row && scope.row.isShowChild ? 'show' : ''"
            :style="{
              height:
                scope.row.isShowChild &&
                scope.row[expandKey] &&
                scope.row[expandKey].list
                  ? `${scope.row[expandKey].currHeightVw}vw`
                  : 0,
            }"
          >
            <template v-if="scope.row.isHasDetailData">
              <span
                class="table_group"
                :class="[
                  scope.row[expandKey].expandClassString,
                  scope.row[expandKey].renderMode,
                ]"
                :style="{
                  paddingLeft: `${
                    compTableColumnData[0][0]
                      ? compTableColumnData[0][0].widthPx
                      : 0
                  }px`,
                }"
              >
                <template
                  v-if="
                    ['ROW', 'GRY', 'FSK', 'RCB'].includes(
                      scope.row[expandKey].renderMode
                    )
                  "
                >
                  <span
                    class="columnItem"
                    v-for="(columData, pIndex) in scope.row[expandKey].list"
                    :key="pIndex"
                  >
                    <span
                      class="playerName-playerLogo-playerGender-teamLogo-teamName"
                    >
                      <span
                        class="playerLogo"
                        :class="[
                          columData['player_logo'] ? 'isLogo' : '',
                          columData['player_gender'],
                        ]"
                      >
                        <img
                          v-if="columData['player_logo']"
                          :src="columData['player_logo']"
                        />
                      </span>
                      <span class="playerOther">
                        <span class="teamInfor">
                          <span
                            class="teamLogo"
                            :class="scope.row['team_logo'] ? 'isLogo' : ''"
                          >
                            <img
                              v-if="scope.row['team_logo']"
                              :src="scope.row['team_logo']"
                            />
                          </span>
                          <span
                            class="teamName"
                            v-text="
                              _valPerFormatHandler(scope.row['team_name'])
                            "
                          ></span>
                        </span>
                        <span
                          class="playerName"
                          v-text="
                            _valPerFormatHandler(columData['player_name'])
                          "
                          @click="
                            goDetail('CSMeetPlayerDetailIndex', columData)
                          "
                        ></span>
                      </span>
                    </span>
                  </span>
                </template>
              </span>
            </template>
          </span>

          <!--[expandKey] tableMode = "eventComp_mode_15" -->
          <span
            v-else-if="
              column.prop === expandKey && tableMode === 'eventComp_mode_15'
            "
            class="expandBox"
            :class="[scope.row && scope.row.isShowChild ? 'show' : '']"
            :style="{
              height:
                scope.row.isShowChild &&
                scope.row[expandKey] &&
                scope.row[expandKey].list
                  ? `${scope.row[expandKey].currHeightVw}vw`
                  : 0,
            }"
          >
            <template v-if="scope.row.isHasDetailData">
              <span
                class="table_group"
                :class="[
                  scope.row[expandKey].expandClassString,
                  scope.row[expandKey].renderMode,
                  competitorType,
                  'overflowXAuto',
                ]"
                :style="{
                  paddingLeft: `${
                    compTableColumnData[0][0]
                      ? compTableColumnData[0][0].widthPx
                      : 0
                  }px`,
                }"
              >
                <template v-if="scope.row[expandKey].renderMode === 'GRY'">
                  <span
                    class="columnItem"
                    v-for="(columData, pIndex) in scope.row[expandKey].list"
                    :key="pIndex"
                  >
                    <span
                      class="playerName-playerLogo-playerGender-teamLogo-teamName"
                    >
                      <span
                        class="playerLogo"
                        :class="[
                          columData['player_logo'] ? 'isLogo' : '',
                          columData['player_gender'],
                        ]"
                      >
                        <img
                          v-if="columData['player_logo']"
                          :src="columData['player_logo']"
                        />
                      </span>
                      <span class="playerOther">
                        <span class="teamInfor">
                          <span
                            class="teamLogo"
                            :class="scope.row['team_logo'] ? 'isLogo' : ''"
                          >
                            <img
                              v-if="scope.row['team_logo']"
                              :src="scope.row['team_logo']"
                            />
                          </span>
                          <span
                            class="teamName"
                            v-text="
                              _valPerFormatHandler(scope.row['team_name'])
                            "
                          ></span>
                        </span>
                        <span
                          class="playerName"
                          v-text="
                            _valPerFormatHandler(columData['player_name'])
                          "
                          @click="
                            goDetail('CSMeetPlayerDetailIndex', columData)
                          "
                        ></span>
                      </span>
                    </span>
                  </span>
                </template>
                <template
                  v-if="
                    ['SMT', 'FRS', 'SWM'].includes(
                      scope.row[expandKey].renderMode
                    )
                  "
                >
                  <template
                    v-if="
                      scope.row[expandKey].list.data &&
                      competitorType &&
                      ['A'].includes(competitorType)
                    "
                  >
                    <span
                      class="columnItem"
                      v-for="(columData, gIndex) in scope.row[expandKey].list
                        .data"
                      :key="gIndex"
                    >
                      <span
                        class="columnItem_row"
                        v-text="
                          _valPerFormatHandler(columData['intermediate_name'])
                        "
                      ></span>
                      <span
                        class="columnItem_row"
                        v-text="
                          `${_valPerFormatHandler(
                            columData['intermediate_result']
                          )}${
                            columData['intermediate_rank']
                              ? ' (' + columData['intermediate_rank'] + ')'
                              : ''
                          }`
                        "
                      ></span>
                    </span>
                  </template>
                  <template
                    v-if="
                      scope.row[expandKey].list.data &&
                      scope.row[expandKey].list.data.length > 0 &&
                      competitorType &&
                      ['T', 'T-GP'].includes(competitorType)
                    "
                  >
                    <span class="playerList">
                      <span
                        class="playerList_item"
                        :class="scope.row[expandKey].tabType"
                        v-for="playerItem in scope.row[expandKey].list.data"
                        :key="playerItem.player_id"
                      >
                        <span
                          class="baton_name"
                          v-if="playerItem['baton_name']"
                          v-text="
                            _valPerFormatHandler(playerItem['baton_name'], '棒')
                          "
                        ></span>
                        <span class="playerName-playerLogo-playerGender">
                          <span
                            class="playerLogo"
                            :class="[
                              playerItem['player_logo'] ? 'isLogo' : '',
                              playerItem['player_gender'],
                            ]"
                          >
                            <img
                              v-if="playerItem['player_logo']"
                              :src="playerItem['player_logo']"
                            />
                          </span>
                          <span class="playerOther">
                            <span
                              class="playerName"
                              v-text="
                                _valPerFormatHandler(playerItem['player_name'])
                              "
                              @click="
                                goDetail('CSMeetPlayerDetailIndex', playerItem)
                              "
                            ></span>
                            <span class="player_result_rank">
                              <span
                                class="player_result"
                                v-text="
                                  _valPerFormatHandler(
                                    playerItem['player_result']
                                  )
                                "
                              ></span>
                              <span
                                class="player_rank"
                                v-text="
                                  playerItem['instant_ranking']
                                    ? `(${playerItem['instant_ranking']})`
                                    : ''
                                "
                              ></span>
                            </span>
                          </span>
                        </span>
                        <span
                          class="columnItem"
                          v-for="(
                            columData, columnIndex
                          ) in playerItem.result_detail"
                          :key="columnIndex"
                        >
                          <span
                            class="columnItem_row"
                            v-text="
                              _valPerFormatHandler(
                                columData['intermediate_name']
                              )
                            "
                          ></span>
                          <span
                            class="columnItem_row"
                            v-text="
                              `${_valPerFormatHandler(
                                columData['intermediate_result']
                              )}${
                                columData['intermediate_rank']
                                  ? ' (' + columData['intermediate_rank'] + ')'
                                  : ''
                              }`
                            "
                          ></span>
                        </span>
                      </span>
                    </span>
                  </template>
                </template>
                <template
                  v-if="
                    ['STK', 'SSK'].includes(scope.row[expandKey].renderMode)
                  "
                >
                  <template
                    v-if="
                      scope.row[expandKey].list.data &&
                      competitorType &&
                      ['A'].includes(competitorType)
                    "
                  >
                    <span
                      class="columnItem"
                      v-for="(columData, gIndex) in scope.row[expandKey].list
                        .data"
                      :key="gIndex"
                    >
                      <span
                        class="columnItem_row"
                        v-text="
                          _valPerFormatHandler(columData['intermediate_name'])
                        "
                      ></span>
                      <span
                        class="columnItem_row"
                        v-text="
                          `${_valPerFormatHandler(
                            columData['intermediate_result']
                          )}${
                            columData['intermediate_rank']
                              ? ' (' + columData['intermediate_rank'] + ')'
                              : ''
                          }`
                        "
                      ></span>
                    </span>
                  </template>
                  <template
                    v-if="
                      scope.row[expandKey].list.data &&
                      competitorType &&
                      ['T'].includes(competitorType)
                    "
                  >
                    <span
                      class="columnItem"
                      v-for="(columData, gIndex) in scope.row[expandKey].list
                        .data"
                      :key="gIndex"
                    >
                      <span
                        class="columnItem_row"
                        v-text="
                          _valPerFormatHandler(columData['intermediate_name'])
                        "
                      ></span>
                      <span
                        class="columnItem_row"
                        v-for="(resColum, resInd) in columData[
                          'intermediate_result'
                        ]"
                        :key="resInd"
                        v-text="`${resColum !== null ? resColum : ''}`"
                      ></span>
                    </span>
                  </template>
                </template>
                <template
                  v-if="
                    ['ROW', 'RCB'].includes(scope.row[expandKey].renderMode) &&
                    scope.row[expandKey].list.data &&
                    competitorType &&
                    ['A', 'D', 'T'].includes(competitorType)
                  "
                >
                  <span
                    class="columnItem"
                    v-for="(columData, gIndex) in scope.row[expandKey].list
                      .data"
                    :key="gIndex"
                  >
                    <span
                      class="columnItem_row"
                      v-text="
                        _valPerFormatHandler(columData['intermediate_name'])
                      "
                    ></span>
                    <span
                      class="columnItem_row"
                      v-for="(resColum, resInd) in columData[
                        'intermediate_result'
                      ]"
                      :key="resInd"
                      v-text="`${resColum !== null ? resColum : ''}`"
                    ></span>
                  </span>
                </template>
                <template
                  v-if="
                    ['ROW', 'RCB'].includes(scope.row[expandKey].renderMode) &&
                    scope.row[expandKey].list.data &&
                    competitorType &&
                    ['D-GP', 'T-GP'].includes(competitorType)
                  "
                >
                  <span
                    class="columnItem"
                    v-for="(columData, pIndex) in scope.row[expandKey].list
                      .data"
                    :key="pIndex"
                  >
                    <span
                      class="playerName-playerLogo-playerGender-teamLogo-teamName"
                    >
                      <span
                        class="playerLogo"
                        :class="[
                          columData['player_logo'] ? 'isLogo' : '',
                          columData['player_gender'],
                        ]"
                      >
                        <img
                          v-if="columData['player_logo']"
                          :src="columData['player_logo']"
                        />
                      </span>
                      <span class="playerOther">
                        <span class="teamInfor">
                          <span
                            class="teamLogo"
                            :class="scope.row['team_logo'] ? 'isLogo' : ''"
                          >
                            <img
                              v-if="scope.row['team_logo']"
                              :src="scope.row['team_logo']"
                            />
                          </span>
                          <span
                            class="teamName"
                            v-text="
                              _valPerFormatHandler(scope.row['team_name'])
                            "
                          ></span>
                        </span>
                        <span
                          class="playerName"
                          v-text="
                            _valPerFormatHandler(columData['player_name'])
                          "
                          @click="
                            goDetail('CSMeetPlayerDetailIndex', columData)
                          "
                        ></span>
                      </span>
                    </span>
                  </span>
                </template>
                <template
                  v-if="
                    ['SBD', 'ATH'].includes(scope.row[expandKey].renderMode)
                  "
                >
                  <template
                    v-if="
                      scope.row[expandKey].list.data &&
                      (scope.row[expandKey].list.data.length >
                        scope.row[expandKey].renderMode ===
                      'SBD'
                        ? 0
                        : 1) &&
                      competitorType &&
                      ['T', 'T-GP'].includes(competitorType)
                    "
                  >
                    <span class="playerList">
                      <span
                        class="playerList_item"
                        :class="scope.row[expandKey].tabType"
                        v-for="playerItem in scope.row[expandKey].list.data"
                        :key="playerItem.player_id"
                      >
                        <span
                          class="baton_name"
                          v-if="playerItem['bib_number']"
                          v-text="
                            _valPerFormatHandler(playerItem['bib_number'])
                          "
                        ></span>
                        <span class="playerName-playerLogo-playerGender">
                          <span
                            class="playerLogo"
                            :class="[
                              playerItem['player_logo'] ? 'isLogo' : '',
                              playerItem['player_gender'],
                            ]"
                          >
                            <img
                              v-if="playerItem['player_logo']"
                              :src="playerItem['player_logo']"
                            />
                          </span>
                          <span class="playerOther">
                            <span
                              class="playerName"
                              v-text="
                                _valPerFormatHandler(playerItem['player_name'])
                              "
                              @click="
                                goDetail('CSMeetPlayerDetailIndex', playerItem)
                              "
                            ></span>
                            <span class="player_result_rank">
                              <span
                                class="player_result"
                                v-text="
                                  _valPerFormatHandler(
                                    playerItem['person_result']
                                  )
                                "
                              ></span>
                              <span
                                class="player_rank"
                                v-text="
                                  playerItem['person_rank_num']
                                    ? `(${playerItem['person_rank_num']})`
                                    : ''
                                "
                              ></span>
                            </span>
                          </span>
                        </span>
                        <span
                          class="columnItem"
                          v-for="(
                            columData, columnIndex
                          ) in playerItem.result_detail"
                          :key="columnIndex"
                        >
                          <span
                            class="columnItem_row"
                            v-text="
                              _valPerFormatHandler(
                                columData['intermediate_name']
                              )
                            "
                          ></span>
                          <span
                            class="columnItem_row"
                            v-text="
                              `${_valPerFormatHandler(
                                columData['intermediate_result']
                              )}${
                                columData['intermediate_rank']
                                  ? ' (' + columData['intermediate_rank'] + ')'
                                  : ''
                              }`
                            "
                          ></span>
                        </span>
                      </span>
                    </span>
                  </template>
                </template>
              </span>
            </template>
          </span>

          <!--[expandKey] tableMode = "eventComp_mode_24" -->
          <span
            class="singlePlayer-team"
            v-else-if="scope.column.property === 'singlePlayer-team'"
          >
            <span
              class="playerName-playerLogo-playerGender-teamLogo-teamName"
              v-for="playerItem in scope.row['player_infos']"
              :key="playerItem.player_id"
            >
              <span
                class="playerLogo"
                :class="[
                  playerItem['player_logo'] ? 'isLogo' : '',
                  playerItem['player_gender'],
                ]"
              >
                <img
                  v-if="playerItem['player_logo']"
                  :src="playerItem['player_logo']"
                />
              </span>
              <span class="playerOther">
                <span class="teamInfor">
                  <span
                    class="teamLogo"
                    :class="scope.row['team_logo'] ? 'isLogo' : ''"
                  >
                    <img
                      v-if="scope.row['team_logo']"
                      :src="scope.row['team_logo']"
                    />
                  </span>
                  <span
                    class="teamName"
                    v-text="_valPerFormatHandler(scope.row['team_name'])"
                  ></span>
                </span>
                <span
                  class="playerName"
                  v-text="_valPerFormatHandler(playerItem['player_name'])"
                  @click="goDetail('CSMeetPlayerDetailIndex', playerItem)"
                ></span>
              </span>
            </span>
          </span>

          <span
            v-else-if="scope.column.property === 'single-player-name'"
            :class="scope.column.property"
          >
            <span
              class="playerName"
              v-text="_valPerFormatHandler(scope.row['player_name'])"
              @click="goDetail('CSMeetPlayerDetailIndex', scope.row)"
            ></span>
          </span>

          <span v-else v-text="scope.row[scope.column.property]"></span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_loadTree_table',
  mixins: [cup_base_data_mixin],
  props: {
    expandKey: {
      type: String,
      default: 'isExpand', //占用展开的id
    },
    sportsId: {
      type: String,
      default: '', //大项id
    },
    tabType: {
      type: String, //确定数据来自于 出场名单'startList'  || 本场数据'localData',
      default: '',
    },
    isExpandAll: {
      type: Boolean,
      default: false, //控制表格头部右侧箭头， true:打开全部展开行；false:关闭全部
    },
    expandColumnCallback: {
      type: Function,
      default: null,
    },
    tableMode: {
      type: String,
      default: '', //类型
    },
    isBroadCastList: {
      //播出单页面不能点击跳转详情
      type: Boolean,
      default: false,
    },
    isClickFlag: {
      type: Boolean,
      default: false,
    },
    parentWidthPx: {
      type: Number, //父级宽度，做监听，因为自适应
      default: 1160,
    },
    tableHeightPx: {
      type: [Number, String],
      default: 0,
    },
    isScrollFlag: {
      type: Boolean, // 是否横向滚动
      default: false,
    },
    variableColWidthVw: {
      type: Number, // 这个在每个table中是唯一的值,不允许出现重复，否则动态计算有问题(将富裕的零碎像素加到这列中)；只有tableCellDefaultWidthVw和variableColWidthVw相同的值在动态计算时会有变化，其他列设置的widthVw值都不会变化
      default: 25.42,
    },
    tableCellDefaultWidthVw: {
      type: Number, // 默认列队宽度，根据自适应计算，不滚动时会变大变小；滚动时只会变大
      default: 5.55,
    },
    defaultWidthVwNum: {
      type: Number, // 默认列的的个数，动态计算时需要
      default: 8,
    },
    tableColumnData: {
      type: Array, // 表格头部的数据
      default: () => {
        return []
        // return [
        //   {
        //     prop: 'date',
        //     label: '日期',
        //     widthVw: 25.42, //对应列的宽度，单位vw
        //     className: 'columnNumLogoNameClass', //单独定制的头部样式class
        //     fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
        //   },
        //   {
        //     prop: 'matchesPlayed',
        //     label: '场次',
        //     widthVw: 5.55,
        //   },
        //   {
        //     prop: 'matchesWon',
        //     label: '胜',
        //     widthVw: 5.55,
        //   },
        //   {
        //     prop: 'matchesDrawn',
        //     label: '平',
        //     widthVw: 5.55,
        //   },
        //   {
        //     prop: 'matchesLost',
        //     label: '负',
        //     widthVw: 5.55,
        //   },
        //   {
        //     prop: 'goalsFor',
        //     label: '进球',
        //     widthVw: 5.55,
        //   },
        //   {
        //     prop: 'goalsAgainst',
        //     label: '失球',
        //     widthVw: 5.55,
        //   },
        //   {
        //     prop: 'goalsDifference',
        //     label: '净胜球',
        //     widthVw: 5.55,
        //   },
        //   {
        //     prop: 'points',
        //     label: '积分',
        //     widthVw: 5.55,
        //   },
        //   // {
        //   //   prop: 'war',
        //   //   label: '邮编12',
        //   //   widthVw: 10,
        //   //   fixed: 'right',
        //   // },
        // ]
      },
    },
    tableData: {
      type: Array,
      default: () => {
        return []
        // return [
        //   {
        //     date: '2016-05-03',
        //     matchesPlayed: 20,
        //     matchesWon: 20,
        //     matchesDrawn: 99,
        //     matchesLost: 1234,
        //     goalsFor: 200333,
        //     goalsAgainst: 1,
        //     points: 231,
        //     war: '1212aasdad',
        //   },
        //   {
        //     date: '2016-05-02',
        //     matchesPlayed: 90,
        //     matchesWon: 92,
        //     matchesDrawn: 100,
        //     matchesLost: 2311,
        //     goalsFor: 200333,
        //     goalsAgainst: 2,
        //     points: 123,
        //     war: '1212aasdad',
        //   },
        // ]
      },
    },
    tableGroupIndexArr: {
      //单个表格 带分组显示
      type: Array,
      default: () => {
        return []
      },
    },
    tableGroupRowBgArr: {
      //单个表格 合并单元格整行的背景色 （例如：金牌争夺赛 || 组1 等整行被合并的单元格）
      type: Array,
      default: () => {
        return []
      },
    },
    spanMethod: {
      type: Function,
      default: null,
    },
    competitorType: {
      type: String,
      default: '',
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  data() {
    return {
      columnIndex: 1,
      arraySpanEventCompModeArr: [
        'medalTally',
        'eventComp_mode_1',
        'eventComp_mode_9',
        'eventComp_mode_10',
        'eventComp_mode_14',
        'eventComp_mode_15',
        'eventComp_mode_22',
        'eventComp_mode_26',
      ],
      arraySpanEventParentChildCompModeArr: [
        'themeItem_delegationEventMedalTally',
      ],
      tableCellDefaultWidthPx: 0, //默认列的宽度px
      groupTitleArr: ['上半场', '下半场'], //射箭用的
    }
  },
  created() {},
  computed: {
    compTableColumnData() {
      let maxColWidthPx = Math.ceil(
        this.variableColWidthVw * (this.clientWidth / 100)
      )
      // let scrollAreaPx
      let estimateAllTableWidth = 0
      let tableCellDefaultWidthPx = Math.ceil(
        this.tableCellDefaultWidthVw * (this.clientWidth / 100)
      )

      this.tableColumnData.forEach((col) => {
        estimateAllTableWidth += Math.ceil(
          col.widthVw * (this.clientWidth / 100)
        )
      })

      const totalColumnNum = this.tableColumnData
        ? this.tableColumnData.length
        : 0
      let maxColWidthPxArr = null

      console.debug(
        'estimateAllTableWidth:',
        this.tableColumnData,
        this.parentWidthPx,
        estimateAllTableWidth,
        tableCellDefaultWidthPx
      )
      let diffVal = estimateAllTableWidth - this.parentWidthPx
      if (diffVal > 0) {
        console.debug('超出了', diffVal)
        // 超出了
        let singlePx = Math.floor(diffVal / this.defaultWidthVwNum)

        // 这里要区分是否有滚动区域，
        if (this.isScrollFlag) {
          if (singlePx == 0) {
            // 不够平分的，将每一个默认的宽度值-1，剩下多余的加到最大的列
            tableCellDefaultWidthPx--
            maxColWidthPx += this.defaultWidthVwNum - diffVal
          } else {
            // 需要滚动逻辑，滚动需要最后一个露出半个
            // 计算可滚动的区域宽度
            let scrollAreaPx =
              this.defaultWidthVwNum * tableCellDefaultWidthPx - diffVal
            let scrollAreaNum = Math.floor(
              scrollAreaPx / tableCellDefaultWidthPx
            )
            console.debug(
              'scrollAreaPx:',
              scrollAreaPx,
              this.defaultWidthVwNum,
              this.defaultWidthVwNum * tableCellDefaultWidthPx,
              scrollAreaNum
            )
            if (scrollAreaNum > 0) {
              // 可滚动区域最少可以放1列以上的
              scrollAreaNum += 0.5
              console.debug(Math.ceil(scrollAreaNum * tableCellDefaultWidthPx))
              if (
                Math.ceil(scrollAreaNum * tableCellDefaultWidthPx) >
                scrollAreaPx
              ) {
                console.debug('可滚动区域小于x.5列的总宽度')
                // 可滚动区域小于x.5列的总宽度,则只能减掉1列，平分空间
                scrollAreaNum--
              }
              tableCellDefaultWidthPx = Math.floor(scrollAreaPx / scrollAreaNum)

              if (tableCellDefaultWidthPx % 2 != 0) {
                // 保证tableCellDefaultWidthPx是个偶数，这样乘以x.5才是得出才是整数
                tableCellDefaultWidthPx--
              }
              maxColWidthPx +=
                scrollAreaPx - tableCellDefaultWidthPx * scrollAreaNum
            } else {
              console.debug('不够1列，暂时不考虑')
            }
          }
        } else {
          if (singlePx == 0) {
            // 如果不滚动则走下面的逻辑
            // 不够平分的，将每一个默认的宽度值-1，剩下多余的加到最大的列
            tableCellDefaultWidthPx--
            maxColWidthPx += this.defaultWidthVwNum - diffVal
          } else {
            // 够平分
            tableCellDefaultWidthPx -= singlePx
            maxColWidthPx -= diffVal % this.defaultWidthVwNum
          }
        }
      } else if (diffVal < 0) {
        // 还有剩余空间,不会出现需要滚动，因为空间有富裕
        console.debug('还有剩余空间', diffVal)
        diffVal = Math.abs(diffVal)
        console.debug(diffVal, this.defaultWidthVwNum)
        if (this.defaultWidthVwNum === 1) {
          // 只有一个平均列时，将多余的全部给最大列
          maxColWidthPx += diffVal
        } else {
          let singlePx = Math.floor(diffVal / this.defaultWidthVwNum)

          if (singlePx == 0) {
            // 不够平分的，将多余的直接加到最大的列
            maxColWidthPx += singlePx
          } else {
            // 够平分
            // 够平分
            tableCellDefaultWidthPx += singlePx
            const maxColWidthNum = totalColumnNum - this.defaultWidthVwNum
            if (maxColWidthNum > 1) {
              // 当出现2个最多列以上的情况
              const forNum = diffVal % this.defaultWidthVwNum
              if (forNum) {
                maxColWidthPxArr = []
                // forNum大于0则要平分
                for (let i = 0; i < maxColWidthNum; i++) {
                  maxColWidthPxArr.push(0)
                }
                for (let i = 0; i < forNum; i++) {
                  maxColWidthPxArr[forNum % maxColWidthNum] += 1
                }
                console.debug('maxColWidthPxArr:', maxColWidthPxArr)
              }
            } else {
              maxColWidthPx += diffVal % this.defaultWidthVwNum
            }
            console.debug(
              '够平分',
              singlePx,
              tableCellDefaultWidthPx,
              maxColWidthPx,
              this.defaultWidthVwNum
            )
          }
        }
      } else {
        // 相等
      }
      maxColWidthPx = maxColWidthPx.toFixed(2)
      console.debug(tableCellDefaultWidthPx, maxColWidthPx)
      const tableColumnData = this.tableColumnData.map((col) => {
        if (col.widthVw == this.tableCellDefaultWidthVw) {
          col.widthPx = tableCellDefaultWidthPx
        } else if (col.widthVw == this.variableColWidthVw) {
          col.widthPx =
            maxColWidthPx + (maxColWidthPxArr ? maxColWidthPxArr.pop() : 0)
        } else {
          col.widthPx = Math.ceil(col.widthVw * (this.clientWidth / 100))
        }
        return col
      })

      let expandColumnData = []
      if (this.tableMode === 'medalTally') {
        if (this.expandColumnCallback) {
          expandColumnData = this.expandColumnCallback(tableColumnData)
        }
      }
      console.debug('expandColumnData:', tableColumnData, expandColumnData)
      return [
        tableColumnData, //表头 && 第一行
        expandColumnData[0] ? expandColumnData[0] : null, //展开第一层
        expandColumnData[1] ? expandColumnData[1] : null, //展开第二层
      ]
    },
  },
  methods: {
    clickPublicTheme(themeItem) {
      // 分享主题
      console.debug('themeItem:', themeItem)
      // const query = this.$route.query
      themeItem.phaseId = themeItem.phaseId ? themeItem.phaseId : 0
      // themeItem.actJson = { medalType: item.medalType, competitorCode: item.competitorCode }
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: themeItem,
        mid: themeItem.matchId ? themeItem.matchId : 0,
      })
    },
    computedExpandPadLeftWidth(index, columArr) {
      // console.debug('computedExpandPadLeftWidth:', index, columArr)
      let padLeftWidth = 0
      if (index === 0) {
        return columArr[0].widthPx
      }
      for (let i = 0; i < columArr.length; i++) {
        padLeftWidth += Number(columArr[i].widthPx)
        if (index - 1 == i) {
          break
        }
      }
      console.debug('padLeftWidth:', padLeftWidth, index)
      return padLeftWidth
    },
    computedExpandOnlyCustomAutoWidthCalc(index, columArr) {
      // 这个是在抛弃computedExpandPadLeftWidth这个方法生产的padding-left值之后，按100%计算的
      // console.debug('computedExpandOnlyCustomAutoWidthCalc:', index, columArr)
      let otherWidth = 0
      columArr.forEach((column, colIndex) => {
        if (colIndex > index) {
          // 这0是为了解决加自身没有值的
          otherWidth += Number(column.widthPx) ? Number(column.widthPx) : 0
        }
      })
      console.debug('otherWidth:', otherWidth)
      return `calc(100% - ${otherWidth}px)`
    },
    isTableAllExpand(flag) {
      this.toParentEvent({
        eventName: 'isTableAllExpandEvent',
        data: flag,
      })
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    open1Child(row) {
      console.debug(row)
      row.isShowChild = !row.isShowChild
      this.toParentEvent({
        eventName: 'clickItemRowArrowEvent',
        data: row.isShowChild,
      })
    },
    open2Child(key, row) {
      console.debug('open2Child:', key)
      let currHeightVw = 0
      if (row) {
        let isSomeChildOpen = false
        row.isExpand.list.forEach((ceil) => {
          currHeightVw += row.isExpand.rowHeightVw
          if (ceil.id === key) {
            ceil.isOpen = !ceil.isOpen
          }
          if (ceil.isOpen) {
            isSomeChildOpen = true
            currHeightVw += ceil.currHeightVw
          }
        })
        row.isExpand.isSomeChildOpen = isSomeChildOpen
        row.isExpand.currHeightVw = currHeightVw
        console.debug(row)
      }
    },
    toParentEvent(data) {
      this.$emit('toParentEvent', data)
    },
    headerRowStyle(row, rowIndex) {
      //  console.debug(row, rowIndex)
      var style = {}
      if (this.isClickFlag) {
        if (this.columnIndex == row.columnIndex) {
          style = {
            backgroundColor: this.currThemeObj.cssStyle.mainColor5,
            color: this.currThemeObj.cssStyle.whiteColor,
          }
        }
      }
      return style
    },
    cellStyle(row) {
      //  console.debug(row)
      if (!this.isClickFlag) return
      if (this.columnIndex == row.columnIndex) {
        return { backgroundColor: `${this.currThemeObj.cssStyle.greyColor7}` }
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.debug(row, columnIndex)
      // if (this.tableMode === 'medalTally') {
      //   if (columnIndex === 7) {
      //     return [1, 2]
      //   } else if (columnIndex === 8) {
      //     return [0, 0]
      //   }
      // }
      if (this.arraySpanEventCompModeArr.includes(this.tableMode)) {
        if (columnIndex === this.tableColumnData.length - 2) {
          return [1, 2]
        } else if (columnIndex === this.tableColumnData.length - 1) {
          return [0, 0]
        }
      }
      if (
        this.tableGroupIndexArr &&
        this.tableGroupIndexArr.length > 0 &&
        this.tableGroupIndexArr.includes(rowIndex)
      ) {
        if (columnIndex === 0) {
          return [1, this.tableColumnData.length]
        } else {
          return [0, 0]
        }
      }

      if (this.arraySpanEventParentChildCompModeArr.includes(this.tableMode)) {
        console.debug(row, column, rowIndex, columnIndex)
        if (row.rowType === 'child') {
          if (columnIndex === 0) {
            return [1, 3]
          } else if (columnIndex > 0 && columnIndex < 3) {
            return [0, 0]
          } else {
            return [1, 1]
          }
        }
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (
        this.tableGroupIndexArr &&
        this.tableGroupIndexArr.length > 0 &&
        this.tableGroupIndexArr.includes(rowIndex) &&
        this.tableGroupRowBgArr.length > 0
      ) {
        return this.tableGroupRowBgArr[0]
      }

      if (
        this.arraySpanEventParentChildCompModeArr.includes(this.tableMode) &&
        row.rowType === 'child'
      ) {
        return 'parentChild_child'
      }
      return ''
    },
    headerClick(column, event) {
      if (!this.isClickFlag) return
      console.debug(column, event)
      let columnIndex = -1
      this.tableColumnData.forEach((col, colIndex) => {
        if (col.prop == column.property) {
          columnIndex = colIndex
        }
      })
      console.debug('columnIndex:', this.columnIndex)
      if (columnIndex < 1) return //数组下标0 为字段：球队
      this.columnIndex = columnIndex
      console.debug('columnIndex:', this.columnIndex)
      this.$emit('clickColumnEvent', column.property)
    },
    goDetail(routerName, item, id) {
      console.debug(routerName, item, this.isBroadCastList)
      if (
        this.isBroadCastList ||
        this.notJumpDetailPage.includes(this.sportCompetitionType)
      )
        return
      if (
        item.player_name === '总计' &&
        this.tableMode === 'eventComp_mode_25'
      ) {
        return
      }
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
  },
}
</script>

<style lang="scss" scoped>
.compreSportsMeet_loadTree_table {
  position: relative;
  width: 100%;
  .table_head_arrow {
    width: 2.788vw;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    height: 3.332vw;
    color: var(--mixtmt_whiteColor);
    .arrowIcon {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      &:hover {
        cursor: pointer;
      }
      .el-icon-arrow-right {
        /* position: absolute;
        top: 0;
        right: 0;
        z-index: 2; */
        width: 2.5vw;
        height: 2.5vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        transition: transform 0.2s linear;
        &.open {
          transform: rotate(90deg);
        }
        &:before {
          content: '\e6e0';
        }
      }
    }
  }
  .cell {
    .arrowIcon {
      width: 100%;
      /* position: relative; */
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      &:hover {
        cursor: pointer;
      }
      .el-icon-arrow-right {
        /* position: absolute;
        top: 0;
        right: 0;
        z-index: 2; */
        width: 2.5vw;
        height: 2.5vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        transition: transform 0.2s linear;
        &.open {
          transform: rotate(90deg);
        }
        &:before {
          content: '\e6e0';
        }
      }
    }
    .playerName-playerLogo-playerGender-teamLogo-teamName {
      height: 4.16vw;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .playerLogo {
        position: relative;
        width: 4.16vw;
        height: 4.16vw;
        border-radius: 50%;
        background-size: 100% auto;
        background-position: left 35%;
        background-repeat: no-repeat;
        background-image: var(--mixtmt_default_playerLogo);
        &::before {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 5;
          width: 1.11vw;
          height: 1.11vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          /* background-image: var(--mixtmt_gender_male_icon); */
        }
        &::after {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        &.F {
          &::before {
            background-image: var(--mixtmt_gender_female_icon);
          }
        }
        &.M {
          &::before {
            background-image: var(--mixtmt_gender_male_icon);
          }
        }
        &.isLogo {
          background-image: none;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .playerOther {
        width: calc(100% - 4.16vw);
        padding: 0 0.694vw;
        height: 4.16vw;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        .teamInfor {
          width: 100%;
          height: 1.66vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .teamLogo {
            width: 2.5vw;
            height: 1.66vw;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor0);
            &.isLogo {
              background-color: transparent;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .teamName {
            padding-left: 0.694vw;
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor2);
          }
        }
        .playerName {
          width: auto;
          max-width: 100%;
          font-size: 1.11vw;
          height: 1.38vw;
          line-height: 1.38vw;
          color: var(--mixtmt_greyColor3);
          text-align: left;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .publishBtn {
      display: block;
      width: 100%;
      text-align: center;
      svg.publishBtn_icon {
        fill: var(--mixtmt_greyColor4);
      }
    }
    .delegationLogo-delegationName {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      .delegationLogo {
        width: 2.083vw;
        height: 1.388vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .delegationName {
        width: calc(100% - 2.083vw);
        padding-left: 1.04vw;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .rankNum-teamLogo-teamName {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 0 0.694vw;
      color: var(--mixtmt_greyColor3);
      .rankNum {
        font-weight: bold;
        width: 2.083vw;
      }
      .teamLogo {
        width: 2.083vw;
        height: 1.388vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        width: auto;
        max-width: calc(100% - 2.083vw - 2.083vw);
        padding-left: 1.04vw;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .teamLogo-teamName {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 0 0.694vw;
      color: var(--mixtmt_greyColor3);
      .teamLogo {
        width: 2.083vw;
        height: 1.388vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        width: auto;
        max-width: calc(100% - 2.083vw);
        padding-left: 1.04vw;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .teamLogo-teamName-playerListString {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 0 0.694vw;
      color: var(--mixtmt_greyColor3);
      .teamLogo {
        width: 2.916vw;
        height: 1.944vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .teamName {
        width: auto;
        padding: 0 1.04vw;
        text-align: left;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .playerList {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        &.A {
          .playerItem_name {
            max-width: 29vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
        &.D {
          .playerItem_name {
            max-width: 14.5vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
        .player_item {
          width: auto;
          position: relative;
          padding-left: 0.972vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .playerItem_name {
            &::before {
              color: var(--mixtmt_greyColor3);
              position: absolute;
              content: '/';
              left: 0;
              top: 50%;
              z-index: 2;
              width: 0.972vw;
              text-align: center;
              transform: translateY(-50%);
            }
          }
          &:first-child {
            padding-left: 0;
            .playerItem_name {
              &::before {
                visibility: hidden;
              }
            }
          }
        }
      }
    }
    .teamLogo-playerListString {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 0 0.694vw;
      color: var(--mixtmt_greyColor3);
      .teamLogo {
        width: 3.125vw;
        height: 2.083vw;
        overflow: hidden;
        background-color: var(--mixtmt_greyColor0);
        &.isLogo {
          background-color: transparent;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .playerList {
        width: calc(100% - 3.125vw);
        padding-left: 1.04vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        &.A {
          .playerItem_name {
            max-width: 29vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
        &.D {
          .playerItem_name {
            max-width: 14.5vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
        .player_item {
          width: auto;
          position: relative;
          padding-left: 0.972vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .playerItem_name {
            &::before {
              color: var(--mixtmt_greyColor3);
              position: absolute;
              content: '/';
              left: 0;
              top: 50%;
              z-index: 2;
              width: 0.972vw;
              text-align: center;
              transform: translateY(-50%);
            }
          }
          &:first-child {
            padding-left: 0;
            .playerItem_name {
              &::before {
                visibility: hidden;
              }
            }
          }
        }
      }
    }
    .singleRow-teamLogoPlayer {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      width: 100%;
      padding: 0 0.694vw;
      color: var(--mixtmt_greyColor3);
      .teamPlayerItem {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        &.A {
          .player_item {
            .playerItem_name {
              width: 100%;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
        &.D {
          padding-top: 0.416vw;
          &:first-child {
            padding-top: 0;
          }
          .player_item {
            .playerItem_name {
              width: 100%;
              text-align: left;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
        .teamLogo {
          position: relative;
          width: 3.125vw;
          height: 2.083vw;
          overflow: hidden;
          background-color: var(--mixtmt_greyColor0);
          &.isLogo {
            background-color: transparent;
          }
          &::before {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            content: '\20';
            border: 1px solid var(--mixtmt_greyColor5);
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .player_item {
          width: calc(100% - 3.125vw);
          position: relative;
          padding: 0 0.972vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          /* .playerItem_name {
            &::before {
              color: var(--mixtmt_greyColor3);
              position: absolute;
              content: '/';
              right: 0;
              top: 50%;
              z-index: 2;
              width: 0.972vw;
              text-align: center;
              transform: translateY(-50%);
            }
          } */
        }
        /* &:last-child {
          .player_item {
            .playerItem_name {
              &::before {
                visibility: hidden;
              }
            }
          }
        } */
      }
    }
    .sportsNameEventName {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      line-height: 1.666vw;
      white-space: normal;
    }

    .delegationLogo-delegationId-delegationName {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      width: 100%;
      .delegationItem {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: auto;
        height: auto;
        background-color: var(--mixtmt_greyColor8);
        padding: 0.208vw;
        .delegationLogo {
          width: 2.71vw;
          height: 1.807vw;
          overflow: hidden;
          background-color: var(--mixtmt_greyColor0);
          &.isLogo {
            background-color: transparent;
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .delegationId {
          width: calc(100% - 2.71vw);
          padding-left: 0.416vw;
          font-size: 0.903vw;
          text-align: center;
        }
      }
      .delegationName {
        padding-top: 0.694vw;
        width: calc(100% - 2.5vw);
        font-size: 0.972vw;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
      }
    }

    .playerListString {
      display: block;
      width: 100%;
      line-height: 1.666vw;
      text-align: left;
      white-space: normal;
    }

    .color {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .colorArea {
        width: 2.43vw;
        height: 1.38vw;
        border-width: 1px;
        border-style: solid;
      }
    }

    .operateArr {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      .operateArr_btn {
        margin-left: 1.388vw;
        width: 5.556vw;
        text-align: center;
        height: 2.083vw;
        border-radius: 0.208vw;
        font-size: 0.972vw;
        line-height: 2.083vw;
        border: 1px solid var(--mixtmt_greyColor7);
        color: var(--mixtmt_greyColor_main);
        &:first-child {
          margin-left: 0;
        }
      }
    }

    .single-player-name {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .playerName {
        width: auto;
        max-width: 100%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: bold;
      }
    }
  }
  .expandBox {
    .playerName-playerLogo-playerGender-teamLogo-teamName {
      height: 4.16vw;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .playerLogo {
        position: relative;
        width: 4.16vw;
        height: 4.16vw;
        border-radius: 50%;
        background-size: 100% auto;
        background-position: left 35%;
        background-repeat: no-repeat;
        background-image: var(--mixtmt_default_playerLogo);
        &::before {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 5;
          width: 1.11vw;
          height: 1.11vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          /* background-image: var(--mixtmt_gender_male_icon); */
        }
        &::after {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        &.F {
          &::before {
            background-image: var(--mixtmt_gender_female_icon);
          }
        }
        &.M {
          &::before {
            background-image: var(--mixtmt_gender_male_icon);
          }
        }
        &.isLogo {
          background-image: none;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .playerOther {
        width: calc(100% - 4.16vw);
        padding: 0 0.694vw;
        height: 4.16vw;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        .teamInfor {
          width: 100%;
          height: 1.66vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .teamLogo {
            width: 2.5vw;
            height: 1.66vw;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor0);
            &.isLogo {
              background-color: transparent;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .teamName {
            padding-left: 0.694vw;
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor2);
          }
        }
        .playerName {
          width: auto;
          max-width: 100%;
          font-size: 1.11vw;
          height: 1.38vw;
          line-height: 1.38vw;
          color: var(--mixtmt_greyColor3);
          text-align: left;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .playerName-playerLogo-playerGender {
      height: 4.16vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;

      .playerLogo {
        position: relative;
        width: 4.16vw;
        height: 4.16vw;
        border-radius: 50%;
        background-size: 100% auto;
        background-position: left 35%;
        background-repeat: no-repeat;
        background-image: var(--mixtmt_default_playerLogo);
        &::before {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 5;
          width: 1.11vw;
          height: 1.11vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          background-image: var(--mixtmt_gender_male_icon);
        }
        &::after {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        &.F {
          &::before {
            background-image: var(--mixtmt_gender_female_icon);
          }
        }
        &.M {
          &::before {
            background-image: var(--mixtmt_gender_male_icon);
          }
        }
        &.isLogo {
          background-image: none;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .playerOther {
        width: calc(100% - 4.16vw);
        padding: 0 0.694vw;
        height: 4.16vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        .playerName {
          width: auto;
          max-width: 100%;
          font-size: 1.11vw;
          height: 1.38vw;
          line-height: 1.38vw;
          color: var(--mixtmt_greyColor3);
          text-align: left;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .player_result_rank {
          width: 100%;
          color: var(--mixtmt_greyColor3);
          .player_result,
          .player_rank {
            font-size: 1.11vw;
            height: 1.38vw;
            line-height: 1.38vw;
          }
          .player_result {
            padding-right: 0.694vw;
          }
        }
      }
    }
    & .SWM {
      .playerList_item {
        .playerName-playerLogo-playerGender {
          width: 11.1vw;
        }
      }
    }
  }

  &.medalTally,
  &.themeItem_medalTally,
  &.themeItem_delegationEventMedalTally,
  &.eventComp_mode_9 {
    .mixtmt_table_header {
      .cell {
        .medalType {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .medalTypeItem {
            width: 1.805vw;
            height: 1.805vw;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            &.ME_GOLD {
              background-image: var(--mixtmt_gold_num_icon);
            }
            &.ME_SILVER {
              background-image: var(--mixtmt_silver_num_icon);
            }
            &.ME_BRONZE {
              background-image: var(--mixtmt_bronze_num_icon);
            }
          }
        }
      }
    }
    .expandBox {
      display: block;
      width: 100%;
      height: auto;
      .expandInfor {
        display: block;
        width: 100%;
        height: auto;
        .expandInfor_group {
          display: block;
          width: 100%;
          height: auto;
        }
      }
      .expand_header_row,
      .expand_body_row {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        & > span {
          text-align: center;
          font-size: 0.972vw;
          padding: 0 0.694vw;
        }
        & > span:first-child {
          padding: 0 2.083vw;
          text-align: left;
        }
      }
      .expand_header_row {
        height: 2.778vw;
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_subColor1_1);
        .expandTdClassName {
          height: 100%;
          position: relative;
          overflow: hidden;
        }
        .arrowIcon {
          position: relative;
          display: block;
          height: 100%;
        }
        .el-icon-arrow-right {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          transition: transform 0.2s linear;
          &:hover {
            cursor: pointer;
          }
          &.open {
            transform: rotate(90deg);
          }
          &:before {
            content: '\e6e0';
          }
        }
      }

      .expand_body_row {
        height: 3.472vw;
        color: var(--mixtmt_mainColor6);
        background-color: var(--mixtmt_greyColor8);
      }
    }
    .expandBox {
      transition: height 0.3s linear;
      overflow: hidden;
      &.show {
        overflow: auto;
      }
      .expand_header_row {
        height: 2.778vw;
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_subColor1_1);
      }

      .expand_body_group {
        display: block;
        transition: height 0.3s linear;
        overflow: hidden;
      }
      .expand_body_row {
        height: 3.472vw;
        color: var(--mixtmt_mainColor6);
        background-color: var(--mixtmt_greyColor8);
        .medalType-playerName-matchNameClass {
          padding: 0 0.694vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          color: var(--mixtmt_greyColor2);
          .medalType {
            width: 1.805vw;
            height: 1.805vw;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            &.ME_GOLD {
              background-image: var(--mixtmt_gold_num_icon);
            }
            &.ME_SILVER {
              background-image: var(--mixtmt_silver_num_icon);
            }
            &.ME_BRONZE {
              background-image: var(--mixtmt_bronze_num_icon);
            }
          }
          .playerName,
          .matchName {
            padding: 0 0.347vw;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 1.11vw;
            text-align: left;
          }
          .playerName {
            width: 24.3vw;
          }
          .matchNameClass {
            width: calc(100% - 24.3vw - 1.805vw);
          }
        }
      }
    }
  }
  &.eventComp_mode_1 {
    /* .playerName-playerLogo-playerGender-teamLogo-teamName {
      width: 34.7vw;
    } */
    .expandBox {
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      transition: height 0.3s linear;
      overflow: hidden;
      .half_table_group {
        width: calc(50% - 0.694vw);
        height: auto;
        background-color: var(--mixtmt_greyColor8);
        .table_title {
          display: block;
          padding-left: 2.083vw;
          font-size: 0.972vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
          width: 100%;
          height: 3.125vw;
          line-height: 3.125vw;
          background-color: var(--mixtmt_greyColor7);
        }
        .table_main {
          width: 100%;
          height: auto;
          .table_head_gruop {
            display: block;
            font-size: 0.972vw;
            height: 3.125vw;
            text-align: center;
            line-height: 3.125vw;
            color: var(--mixtmt_greyColor3);
            font-weight: bold;
          }
          .customTable {
            width: 100%;
            height: auto;
            display: table;
          }

          .customTable_row {
            display: table-row;
            height: 3.125vw;
            &:first-child {
              .customTable_row_cell {
                border-bottom: 1px solid var(--mixtmt_greyColor7);
              }
            }
          }

          .customTable_row_cell {
            display: table-cell;
            font-size: 0.833vw;
            line-height: 3.125vw;
            color: var(--mixtmt_greyColor3);
            font-weight: bold;
            text-align: center;
            width: 5%;
            vertical-align: middle;
          }
        }
      }
    }
  }

  &.eventComp_mode_3 {
    .playerName-playerLogo-playerGender-teamLogo-teamName-FEN {
      height: 3.604vw;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .playerLogo {
        position: relative;
        width: 3.604vw;
        height: 3.604vw;
        border-radius: 50%;
        background-size: 100% auto;
        background-position: left 35%;
        background-repeat: no-repeat;
        background-image: var(--mixtmt_default_playerLogo);
        &::before {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 5;
          width: 1.11vw;
          height: 1.11vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          /* background-image: var(--mixtmt_gender_male_icon); */
        }
        &::after {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        &.F {
          &::before {
            background-image: var(--mixtmt_gender_female_icon);
          }
        }
        &.M {
          &::before {
            background-image: var(--mixtmt_gender_male_icon);
          }
        }
        &.isLogo {
          background-image: none;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .playerOther {
        width: calc(100% - 3.604vw);
        padding: 0 0.694vw;
        height: 3.604vw;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        .teamInfor {
          width: 100%;
          height: 1.66vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .teamLogo {
            width: 2.5vw;
            height: 1.66vw;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor0);
            &.isLogo {
              background-color: transparent;
            }
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .teamName {
            padding-left: 0.694vw;
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor2);
          }
        }
        .playerName {
          width: auto;
          max-width: 100%;
          font-size: 0.972vw;
          height: 1.66vw;
          line-height: 1.66vw;
          color: var(--mixtmt_greyColor3);
          text-align: left;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  &.eventComp_mode_9,
  &.eventComp_mode_15 {
    .expandBox {
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      transition: height 0.3s linear;
      overflow: hidden;
      .table_group {
        width: 100%;
        height: auto;
        background-color: var(--mixtmt_greyColor8);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        &.ROW:not(.A-GP, .D-GP, .T-GP) {
          padding-left: 0 !important;
          justify-content: center;
          .columnItem {
            justify-content: space-evenly;
            .columnItem_row {
              &:nth-child(2),
              &:nth-child(3),
              &:nth-child(4) {
                text-align: right;
                font-size: 0.833vw;
                line-height: 1.11vw;
                height: 1.11vw;
                color: var(--mixtmt_greyColor3);
                font-weight: bold;
              }
              &:nth-child(4) {
                padding: 0 1.21vw 0 0;
              }
            }
          }
        }
        &.ROW.D-GP,
        &.ROW.T-GP {
          flex-wrap: wrap;
          .columnItem {
            width: 25%;
            &::before,
            &::after {
              visibility: hidden;
            }
          }
        }
        &.STK,
        &.SSK {
          &.overflowXAuto {
            overflow-x: auto;
            flex-wrap: nowrap;
          }
        }
        &.SWM {
          justify-content: center;
          .columnItem {
            justify-content: space-evenly;
            .columnItem_row {
              &:nth-child(2) {
                font-size: 0.833vw;
                line-height: 2.083vw;
                height: 2.083vw;
                color: var(--mixtmt_greyColor3);
                font-weight: bold;
              }
            }
          }
          &.overflowXAuto {
            overflow-x: auto;
            justify-content: flex-start;
          }
        }
        .columnItem {
          position: relative;
          min-width: 6.25vw;
          height: 6.94vw;
          padding: 0.694vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          background-color: var(--mixtmt_greyColor8);
          &::before {
            content: '\20';
            position: absolute;
            left: 0;
            top: 50%;
            z-index: 2;
            width: 1px;
            height: 70%;
            background-color: var(--mixtmt_greyColor0);
            transform: translateY(-50%);
          }
          &:last-child {
            &::after {
              content: '\20';
              position: absolute;
              right: 0;
              top: 50%;
              z-index: 2;
              width: 1px;
              height: 70%;
              background-color: var(--mixtmt_greyColor0);
              transform: translateY(-50%);
            }
          }
          .columnItem_row {
            width: 100%;
            text-align: center;
            font-size: 0.972vw;
            line-height: 1.38vw;
            height: 1.38vw;
            color: var(--mixtmt_greyColor3);
            font-weight: bold;
            &:first-child {
              font-size: 0.833vw;
              line-height: 1.11vw;
              height: 1.11vw;
              color: var(--mixtmt_greyColor2);
            }
          }
        }
      }
    }
  }

  &.eventComp_mode_10,
  &.eventComp_mode_15,
  &.eventComp_mode_22,
  &.eventComp_mode_26 {
    .expandBox {
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      transition: height 0.3s linear;
      overflow: hidden;
      .playerList {
        width: 100%;
        height: auto;
        background-color: var(--mixtmt_greyColor8);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        .playerList_item {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          &.startList {
            height: 6.94vw;
            .playerName-playerLogo-playerGender {
              width: 34.7vw;
            }
          }
          &.localData,
          &.singleResult,
          &.groupResult {
            height: 6.94vw;
            .playerName-playerLogo-playerGender {
              width: 20.83vw;
            }
          }
          &.teamResult {
            height: 5.55vw;
            .personResult {
              font-size: 0.972vw;
            }
          }
          .baton_name {
            font-size: 0.972vw;
            color: var(--mixtmt_greyColor3);
            width: 4.16vw;
            text-align: center;
          }
          .columnItem {
            position: relative;
            min-width: 6.25vw;
            height: 6.94vw;
            padding: 0.694vw;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            &::before {
              content: '\20';
              position: absolute;
              left: 0;
              top: 50%;
              z-index: 2;
              width: 1px;
              height: 70%;
              background-color: var(--mixtmt_greyColor0);
              transform: translateY(-50%);
            }
            &:last-child {
              &::after {
                content: '\20';
                position: absolute;
                right: 0;
                top: 50%;
                z-index: 2;
                width: 1px;
                height: 70%;
                background-color: var(--mixtmt_greyColor0);
                transform: translateY(-50%);
              }
            }
            .columnItem_row {
              width: 100%;
              text-align: center;
              font-size: 0.833vw;
              line-height: 1.38vw;
              height: 1.38vw;
              color: var(--mixtmt_greyColor3);
              font-weight: bold;
              &:first-child {
                font-size: 0.833vw;
                line-height: 1.11vw;
                height: 1.11vw;
                color: var(--mixtmt_greyColor2);
              }
              &:nth-child(2) {
                line-height: 2.083vw;
                height: 2.083vw;
              }
            }
          }
          .personResult,
          .personRank {
            font-size: 0.833vw;
            text-align: center;
          }
        }
      }
      .customDIV_table {
        position: relative;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        padding: 2.638vw 0 0.694vw 0;
        background-color: var(--mixtmt_greyColor8);
        .group_title {
          display: block;
          position: absolute;
          top: 0.694vw;
          left: 50%;
          z-index: 2;
          transform: translateX(-50%);
          width: 100%;
          text-align: center;
          font-size: 0.972vw;
          line-height: 1.944vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
        .rowData {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          height: 1.944vw;
          &.fontBold {
            .rowData_item {
              font-weight: bold;
            }
          }
          .rowData_item {
            width: 5.55vw;
            font-size: 0.833vw;
            color: var(--mixtmt_greyColor3);
            text-align: center;
            &.groupItem {
              width: 3.47vw;
            }
            &.textLineThrough {
              /* textLineThroughArr 数组中包含的字段都是带横杠的； textLineThroughArr 可选字段，没有则全部不加横杠*/
              text-decoration: line-through;
            }
          }
        }
      }
    }
  }

  &.eventComp_mode_14 {
    .expandBox {
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      transition: height 0.3s linear;
      overflow: hidden;
      .table_group {
        width: 100%;
        height: auto;
        background-color: var(--mixtmt_greyColor8);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .columnItem {
          position: relative;
          width: 25%;
          height: 6.94vw;
          padding: 0.694vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
        }
      }
    }
  }

  &.eventComp_mode_15 {
    .expandBox {
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      transition: height 0.3s linear;
      overflow: hidden;
      .table_group {
        width: 100%;
        height: auto;
        background-color: var(--mixtmt_greyColor8);
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        &.ROW {
          .columnItem {
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              height: 4.16vw;
              width: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              .playerLogo {
                position: relative;
                width: 4.16vw;
                height: 4.16vw;
                border-radius: 50%;
                background-size: 100% auto;
                background-position: left 35%;
                background-repeat: no-repeat;
                background-image: var(--mixtmt_default_playerLogo);
                &::before {
                  position: absolute;
                  content: '\20';
                  bottom: 0;
                  right: 0;
                  width: 1.11vw;
                  height: 1.11vw;
                  background-size: 100% 100%;
                  background-repeat: no-repeat;
                  background-position: center;
                  /* background-image: var(--mixtmt_gender_male_icon); */
                }
                &.F {
                  &::before {
                    background-image: var(--mixtmt_gender_female_icon);
                  }
                }
                &.M {
                  &::before {
                    background-image: var(--mixtmt_gender_male_icon);
                  }
                }
                &.isLogo {
                  background-image: none;
                }
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  border-radius: 50%;
                }
              }
              .playerOther {
                width: calc(100% - 4.16vw);
                padding: 0 0.694vw;
                height: 4.16vw;
                display: flex;
                display: -webkit-flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;
                .teamInfor {
                  width: 100%;
                  height: 1.66vw;
                  display: flex;
                  display: -webkit-flex;
                  justify-content: flex-start;
                  align-items: center;
                  .teamLogo {
                    width: 2.5vw;
                    height: 1.66vw;
                    overflow: hidden;
                    background-color: var(--mixtmt_greyColor0);
                    &.isLogo {
                      background-color: transparent;
                    }
                    img {
                      display: block;
                      width: 100%;
                      height: 100%;
                      object-fit: contain;
                    }
                  }
                  .teamName {
                    padding-left: 0.694vw;
                    font-size: 0.972vw;
                    color: var(--mixtmt_greyColor2);
                  }
                }
                .playerName {
                  width: auto;
                  max-width: 100%;
                  font-size: 1.11vw;
                  height: 1.38vw;
                  line-height: 1.38vw;
                  color: var(--mixtmt_greyColor3);
                  text-align: left;
                  font-weight: bold;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
        }
        /* .columnItem {
          position: relative;
          width: 25%;
          height: 6.94vw;
          padding: 0.694vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
        } */
      }
    }
  }

  &.eventComp_mode_19 {
    .playerName-playerLogo-playerGender-teamLogo-teamName {
      width: 16.66vw;
    }
    .playerName-playerLogo {
      height: 4.16vw;
      width: 20.83vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      .playerLogo {
        position: relative;
        width: 4.16vw;
        height: 4.16vw;
        border-radius: 50%;
        background-size: 100% auto;
        background-position: left 35%;
        background-repeat: no-repeat;
        background-image: var(--mixtmt_default_playerLogo);
        &::before {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 5;
          width: 1.11vw;
          height: 1.11vw;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
          /* background-image: var(--mixtmt_gender_male_icon); */
        }
        &::after {
          position: absolute;
          content: '\20';
          bottom: 0;
          right: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        &.F {
          &::before {
            background-image: var(--mixtmt_gender_female_icon);
          }
        }
        &.M {
          &::before {
            background-image: var(--mixtmt_gender_male_icon);
          }
        }
        &.isLogo {
          background-image: none;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      .playerName {
        width: calc(100% - 4.16vw);
        padding-left: 0.347vw;
        font-size: 1.11vw;
        height: 1.38vw;
        line-height: 1.38vw;
        color: var(--mixtmt_greyColor3);
        text-align: left;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  &.eventComp_mode_24 {
    .teamLogo-teamName-playerListString {
      .playerList {
        /* &.A {
          .playerItem_name {
            max-width: 29vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        } */
        &.D {
          .playerItem_name {
            max-width: 7.5vw;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
  }
}
.mixtmt_pc {
  .compreSportsMeet_loadTree_table:not(.onlyDisplay) {
    &.medalTally,
    &.themeItem_medalTally,
    &.themeItem_delegationEventMedalTally {
      .expand_header_row {
        &:hover {
          background-color: var(--mixtmt_subColor1_1);
        }
      }
      .expand_body_row {
        &:hover {
          background-color: var(--mixtmt_mainColor);
          .medalType-playerName-matchNameClass {
            color: var(--mixtmt_table_hoverRowColor);
          }
        }
      }
    }
    .expand_body_row {
      &:hover {
        color: var(--mixtmt_table_headerColor);
        background-color: var(--mixtmt_table_headerBg);
      }
    }
    .publishBtn {
      &:hover {
        cursor: pointer;
        svg.publishBtn_icon {
          fill: var(--mixtmt_subColor1_1);
        }
      }
    }
    .cell {
      .playerName-playerLogo-playerGender-teamLogo-teamName,
      .playerName-playerLogo-playerGender-teamLogo-teamName-FEN {
        .playerOther {
          .playerName {
            &:hover {
              cursor: pointer;
              color: var(--mixtmt_subColor1_1);
              text-decoration: underline;
            }
          }
        }
      }
      .operateArr_btn {
        &:hover {
          cursor: pointer;
          background-color: var(--mixtmt_subColor1_1);
          color: var(--mixtmt_table_hoverRowColor);
        }
      }
      .rankNum-teamLogo-teamName {
        &:hover {
          color: var(--mixtmt_table_hoverRowColor);
          .teamName {
            &:hover {
              cursor: pointer;
              text-decoration: underline;
            }
          }
        }
      }
      .teamLogo-teamName {
        .teamName {
          &:hover {
            cursor: pointer;
            color: var(--mixtmt_subColor1_1);
            text-decoration: underline;
          }
        }
      }
      .teamLogo-teamName-playerListString,
      .teamLogo-playerListString {
        .playerList {
          .player_item {
            .playerItem_name {
              &:hover {
                cursor: pointer;
                color: var(--mixtmt_subColor1_1);
                text-decoration: underline;
              }
            }
          }
        }
      }
      .singleRow-teamLogoPlayer {
        .teamPlayerItem {
          .player_item {
            .playerItem_name {
              &:hover {
                cursor: pointer;
                color: var(--mixtmt_subColor1_1);
                text-decoration: underline;
              }
            }
          }
        }
      }
      .playerName-playerLogo {
        .playerName {
          &:hover {
            cursor: pointer;
            color: var(--mixtmt_subColor1_1);
            text-decoration: underline;
          }
        }
      }
    }
    .expandBox {
      .playerName-playerLogo-playerGender-teamLogo-teamName {
        .playerOther {
          .playerName {
            &:hover {
              cursor: pointer;
              color: var(--mixtmt_subColor1_1);
              text-decoration: underline;
            }
          }
        }
      }
      .playerName-playerLogo-playerGender {
        .playerOther {
          .playerName {
            &:hover {
              cursor: pointer;
              color: var(--mixtmt_subColor1_1);
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.compreSportsMeet_loadTree_table {
  &.medalTally,
  &.themeItem_medalTally,
  &.themeItem_delegationEventMedalTally {
    .el-table {
      .el-table__header {
        background-image: linear-gradient(
          135deg,
          var(--mixtmt_theme_cascaderSelectPop_1_1) 0%,
          var(--mixtmt_theme_cascaderSelectPop_1_2) 100%
        );
        border-radius: 0.416vw;
      }
      .mixtmt_table_header {
        background-color: transparent;
        th.el-table__cell {
          padding: 0;
          background-color: transparent;
          background: transparent;
          color: var(--mixtmt_whiteColor);
          height: 2.778vw;
          &:first-child {
            border-radius: 0.347vw 0 0 0.347vw;
          }
          &:last-child {
            border-radius: 0 0.347vw 0.347vw 0;
          }
          & > .cell {
            padding: 0;
            font-size: 0.972vw;
            line-height: 1.388vw;
            text-align: center;
          }
          &.columnNumLogoNameClass {
            & > .cell {
              padding-left: 0.694vw;
              text-align: left;
            }
          }
        }
      }
      th.el-table__cell.is-leaf {
        border: 0;
      }
      .el-table__row {
        &.parentChild_child {
          background-color: var(--mixtmt_subColor_main);
          border-radius: 0.347vw;
          /* background-color: var(--mixtmt_subColor1_2); */
          /* color: var(--mixtmt_whiteColor); */
          & > td:first-child {
            .cell {
              padding-left: 2.083vw;
              text-align: left;
            }
          }
        }
        &:hover {
          color: var(--mixtmt_table_hoverRowColor);
          background-color: var(--mixtmt_mainColor);
          .el-table__expand-icon {
            color: var(--mixtmt_table_hoverRowColor);
          }
        }
        .el-table__expand-icon {
          font-size: 0.972vw;
        }
      }
      .el-table__cell {
        padding: 0.694vw 0;
      }
      .el-table__expanded-cell {
        padding: 0;
      }
      & td.el-table__cell,
      & th.el-table__cell.is-leaf {
        border: 0;
      }
      /* & td:last-child,
      & th:last-child {
        display: inherit;
      } */
    }
  }
  &.eventComp_mode_1 {
    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      border-bottom: 0;
    }
    .el-table td.el-table__expanded-cell {
      border-bottom: 1px solid var(--mixtmt_greyColor12);
    }
  }

  &.eventComp_mode_3 {
    .el-table__body {
      .columnPlayerGroupClass-FEN {
        padding: 0.278vw 0;
      }
      .FEN_boutItem {
        position: relative;
        .cell {
          .FEN_boutItem_cell {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            &.notVal {
              background-color: var(--mixtmt_greyColor8);
            }
            &.valIsV {
              background-size: 80% 80%;
              background-repeat: no-repeat;
              background-position: center;
              background-image: var(--mixtmt_matchDetail_table_v_icon);
            }
          }
        }
      }
    }
  }

  &.eventComp_mode_9,
  &.eventComp_mode_10,
  &.eventComp_mode_22,
  &.eventComp_mode_26,
  &.eventComp_mode_14,
  &.eventComp_mode_15 {
    .el-table td.el-table__cell,
    .el-table th.el-table__cell.is-leaf {
      border-bottom: 0;
    }
    .el-table td.el-table__expanded-cell {
      border-bottom: 1px solid var(--mixtmt_greyColor12);
    }
  }
  &.eventComp_mode_3,
  &.eventComp_mode_9,
  &.eventComp_mode_10,
  &.eventComp_mode_22,
  &.eventComp_mode_26,
  &.eventComp_mode_14,
  &.eventComp_mode_15,
  &.eventComp_mode_16 {
    /* .el-table__header {
      & td:last-child,
      & th:last-child {
        display: inherit;
      }
    } */
    .el-table {
      .teamLogo-teamName {
        height: 2.788vw;
        .teamLogo {
          width: 2.916vw;
          height: 1.944vw;
          overflow: hidden;
          background-color: var(--mixtmt_greyColor0);
          &.isLogo {
            background-color: transparent;
          }
        }
      }
    }
  }

  .el-table {
    font-size: 0;
    color: var(--mixtmt_table_rowColor);
    .mixtmt_table_header {
      th.el-table__cell {
        padding: 0.972vw 0;
        background-color: var(--mixtmt_table_headerBg);
        color: var(--mixtmt_table_headerColor);
        height: 3.332vw;
        & > .cell {
          padding: 0;
          font-size: 1.11vw;
          line-height: 1.388vw;
          text-align: center;
        }
        &.columnNumLogoNameClass {
          & > .cell {
            padding-left: 3.472vw;
            text-align: left;
          }
        }
        &.columnTitleLeft {
          & > .cell {
            padding-left: 0.694vw;
            text-align: left;
          }
        }
        &.columnPlayerGroupClass {
          & > .cell {
            padding-left: 4.16vw;
            text-align: left;
          }
        }
        &.columnTeamLogoTeamNameClass {
          & > .cell {
            padding-left: 4.16vw;
            text-align: left;
          }
        }
        &.columnTextLeftClass {
          & > .cell {
            text-align: left;
            padding-left: 0.694vw;
          }
        }
      }
    }
    .el-table__cell {
      padding: 0.833vw 0;
      border-bottom: 1px solid var(--mixtmt_greyColor12);
    }
    .el-table__expanded-cell {
      padding: 0;
    }
    .cell {
      font-size: 1.11vw;
      line-height: 1.25vw;
      text-align: center;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .columnNumLogoNameClass {
      .cell {
        text-align: left;
      }
    }
    .groupBg_subMain05_row {
      background: var(--mixtmt_subColor_main05);
      .cell {
        text-align: left;
        font-weight: bold;
        color: var(--mixtmt_greyColor3);
      }
    }
  }

  &.eventComp_mode_3 {
    &.combinedResult {
      .el-table {
        .cell {
          font-size: 0.972vw;
          line-height: 1.25vw;
        }
      }
    }
  }
  &.eventComp_mode_23 {
    .el-table--border .el-table__cell:first-child .cell {
      padding-left: 0.694vw;
    }
    /* .el-table th.el-table__cell.is-leaf {
      border-bottom: 0;
    } */
    .mixtmt_table_header {
      .el-table__cell {
        border-right: 0;
      }
    }
  }
}

.el-table__expand-icon > .el-icon {
  margin: 0;
  transform: translate(-50%, -50%);
}
.el-table {
  color: var(--mixtmt_table_rowColor);
  .expandTdClassName .cell {
    padding: 0;
  }
  .cell {
    padding: 0 0.694vw;
  }
}

#app.mixtmt_pc .compreSportsMeet_loadTree_table:not(.onlyDisplay) {
  &.click .el-table {
    .mixtmt_table_header {
      th.el-table__cell {
        cursor: pointer;
        &:first-child {
          cursor: default;
        }
        &:not(:first-child):hover {
          background-color: var(--mixtmt_mainColor5);
          color: var(--mixtmt_table_hoverRowColor);
        }
      }
    }
  }
  &.medalTally,
  &.combat_groupStage {
    .el-table__body tr.hover-row.current-row > td.el-table__cell,
    .el-table__body
      tr.hover-row.el-table__row--striped.current-row
      > td.el-table__cell,
    .el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell,
    .el-table__body tr.hover-row > td.el-table__cell,
    .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
      background-color: var(--mixtmt_table_hoverRowColorBg);
      color: var(--mixtmt_table_hoverRowColor);
      /* .playerName-playerLogo-playerGender-teamLogo-teamName,
    .playerName-playerLogo-playerGender-teamLogo-teamName-FEN {
      .playerOther {
        .teamInfor .teamName,
        .playerName {
          color: var(--mixtmt_table_hoverRowColor);
        }
      }
    } */
      /* .cell {
      .teamLogo-teamName,
      .teamLogo-teamName-playerListString {
        & .playerList .player_item .playerItem_name::before {
          color: var(--mixtmt_table_hoverRowColor);
        }
        color: var(--mixtmt_table_hoverRowColor);
      }
    } */
    }
  }
  .el-table--enable-row-hover
    .el-table__body
    tr:hover
    > td.el-table__cell
    .rankNum-teamLogo-teamName,
  .el-table__body tr.hover-row .rankNum-teamLogo-teamName {
    /* 积分榜 第一列 */
    color: var(--mixtmt_table_hoverRowColor);
  }
  &.none {
    .cell {
      .rankNum-teamLogo-teamName {
        &:hover {
          .teamName {
            &:hover {
              cursor: default;
              text-decoration: none;
            }
          }
        }
      }
    }
  }
  &.eventComp_mode_25 {
    .el-table__body tr.hover-row.current-row > td.el-table__cell,
    .el-table__body
      tr.hover-row.el-table__row--striped.current-row
      > td.el-table__cell,
    .el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell,
    .el-table__body tr.hover-row > td.el-table__cell {
      background-color: transparent;
      .single-player-name {
        color: var(--mixtmt_subColor1_1);
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .el-table__body tr.hover-row {
      &:last-child {
        .columnTextLeftClass {
          .cell {
            .single-player-name {
              color: var(--mixtmt_greyColor2);
              text-decoration: none;
              cursor: default;
            }
          }
        }
      }
    }
  }
}

#app.mixtmt_pc .compreSportsMeet_loadTree_table {
  &.notJumpDetailPageClass {
    *:not(.publishBtn) {
      cursor: default !important;
    }
  }
  &.onlyDisplay {
    &.combat_groupStage {
      .el-table__body tr.hover-row.current-row > td.el-table__cell,
      .el-table__body
        tr.hover-row.el-table__row--striped.current-row
        > td.el-table__cell,
      .el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell,
      .el-table__body tr.hover-row > td.el-table__cell,
      .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
        background-color: var(--mixtmt_table_hoverRowColorBg);
        color: inherit;
      }
    }
  }
}

/* #app .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--mixtmt_mainColor);
  color: var(--mixtmt_table_hoverRowColor);
} */
</style>
